/**
 * @ Author: Housefolios
 * @ Create Time: 2021-12-01 15:08:58
 * @ Modified by: David Helmick
 * @ Modified time: 2025-12-17 17:01:53
 * @ Description: Fix & Flip Strategy Analysis page
 */

import React, { useEffect, Suspense, lazy, useState } from 'react'
import {
  strategyBlockSpacerSx,
  strategyBorderMutedSx,
  strategyCardTitleSx,
  strategyCenterTextSx,
  strategyDarkTextSx,
  strategyFont16Sx,
  strategyFullHeight100Sx,
  strategyFullWidthSx,
  strategyIconGap20Style,
  strategyIconGap5Style,
  strategyIconGapStyle,
  strategyInlineFlexSx,
  strategyLinkUnderlineBlueSx,
  strategyMarginBottom10Sx,
  strategyMarginTop25Sx,
  strategyMarginTop35Sx,
  strategyMetricGrayBgSx,
  strategyMetricRowFlexSx,
  strategyMetricRowSx,
  strategyMinHeight50Sx,
  strategyMutedDividerSx,
  strategyMutedPadXSx,
  strategyMutedTextSx,
  strategyNavyBgSx,
  calcDialogPaperSx,
  strategyPadBottom20FullSx,
  strategyPadBottom20Sx,
  strategyTableCellRightSx,
  strategyTableRowSx,
  strategyTextMuted802Sx,
  strategyWhiteBlueChipSx,
  strategyWhiteTextSx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CountUp from '@/utils/SafeCountUp'
import {
  filter,
  map,
  round,
  sum,
  concat,
  every,
  isEmpty,
  isNil,
  includes,
  max,
} from '@/utils/lodash'
const Chart = lazy(() => import('@/utils/SafeApexChart'))

import {
  Grid,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormGroup,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  MenuItem,
  Tooltip,
  Typography,
  Select,
  Box,
} from '@mui/material'

import ContactAgent from '../../../Marketplace/ContactAgent'
import GaugeChart from '@/utils/SafeGaugeChart'

import withSession from '@/housefolios-components/Session/withSession'

import { assumptionsOptions } from '@/housefolios-components/AssumptionsSettings/Accordion' //SPECIFIC COMMENT: Don't remove. Used for rehab card fields
import { DEFAULT_ANALYTICS } from '@/housefolios-components/Property/fragments'

import {
  ContactInformation,
  getCashEntryFee,
  getCreativeEntryFee,
  getPitiTotal,
} from '@/utils/loanBalance'
import SubtoPITICash from '@/housefolios-components/Dialogs/SubtoPITI/Cash/'
import SubtoPITICreative from '@/housefolios-components/Dialogs/SubtoPITI/Creative/'
import CommentsDialog from '@/housefolios-components/Dialogs/Comments'
import {
  FixFlipAcquisitionExpensesTour,
  FixFlipComparablePropertiesTour,
  FixFlipDispositionExpensesTour,
  FixFlipFinancingTour,
  FixFlipGrossMonthlyIncomeRentRangeTour,
  FixFlipGrossMonthlyIncomeSingleRentTour,
  FixFlipHoldingExpensesTour,
  FixFlipNetProfitFromSaleTour,
  FixFlipRehabExpensesDetailedRehabTour,
  FixFlipRehabExpensesFlippingAmericaRehabTour,
  FixFlipRehabExpensesRehabTierTour,
  FixFlipRehabExpensesSingleRehabValueTour,
  FixFlipStrategyTour,
  FixFlipTargetsTour,
} from './tours'
import {
  ComparablePropertiesCard,
  DeactiveCard,
  StrategyCard,
  StrategyPageBase,
  TargetsCard,
  calculateCompData,
  createBasicChartOptions,
  createChartColors,
  createCurrencyFormat,
  createDonutChartOptions,
  createPercentageFormat,
  createStrategySummary,
  useStrategyPage,
} from '../Common'

import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

function CenterPageFixFlip(props) {
  const {
    property,
    propertyInput,
    analysisInput,
    assumptionsInput,
    renderInputFields,
  } = props

  const {
    modal1,
    maxOfferDescription,
    openStrategyTour,
    openTargetsTour,
    openNetProfitTour,
    openComparablePropertiesTour,
    toggle1,
    toggle1Close,
    toggleMaxOffer,
    toggleStrategyTour,
    toggleTargetsTour,
    toggleNetProfitTour,
    toggleComparablePropertiesTour,
    closeStrategyTour,
    closeTargetsTour,
    closeNetProfitTour,
    closeComparablePropertiesTour,
  } = useStrategyPage({ strategyName: 'Fix & Flip'  })

  const [
    openFixFlipAcquisitionExpensesTour,
    setOpenFixFlipAcquisitionExpensesTour,
  ] = useState(false)
  // const [openFixFlipMonthlyIncomeTour, setOpenFixFlipMonthlyIncomeTour] = useState(false)
  const [
    openFixFlipGrossMonthlyIncomeSingleRentTour,
    setOpenFixFlipGrossMonthlyIncomeSingleRentTour,
  ] = useState(false)
  const [
    openFixFlipGrossMonthlyIncomeRentRangeTour,
    setOpenFixFlipGrossMonthlyIncomeRentRangeTour,
  ] = useState(false)
  const [
    openFixFlipRehabExpensesSingleRehabValueTour,
    setOpenFixFlipRehabExpensesSingleRehabValueTour,
  ] = useState(false)
  const [
    openFixFlipRehabExpensesDetailedRehabTour,
    setOpenFixFlipRehabExpensesDetailedRehabTour,
  ] = useState(false)
  const [
    openFixFlipRehabExpensesRehabTierTour,
    setOpenFixFlipRehabExpensesRehabTierTour,
  ] = useState(false)
  const [
    openFixFlipRehabExpensesFlippingAmericaRehabTour,
    setOpenFixFlipRehabExpensesFlippingAmericaRehabTour,
  ] = useState(false)
  const [
    openFixFlipHoldingExpensesTour,
    setOpenFixFlipHoldingExpensesTour,
  ] = useState(false)
  const [openFixFlipFinancingTour, setOpenFixFlipFinancingTour] =
    useState(false)
  const [
    openFixFlipDispositionExpensesTour,
    setOpenFixFlipDispositionExpensesTour,
  ] = useState(false)

  const [openConfirmLender, setOpenConfirmLender] = useState(false)

  const toggleOpenConfirmLender = () => {
    setOpenConfirmLender(!openConfirmLender)
  }

  useEffect(() => {
    if (analysisInput.lender !== analysis.lender)
      toggleOpenConfirmLender()
  }, [analysisInput.lender])

  // const { activeOrg = {} } = props.session.me || {}
  const activeOrg = property?.portfolio?.organization
  const { acquisition = {}, assumptions = {} } = property
  const { analytics = DEFAULT_ANALYTICS, analysis = {} } = acquisition

  const currencyFormat = createCurrencyFormat()
  const currencyFormat2 = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const percentageFormat = createPercentageFormat()
  const pieColors = createChartColors()

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked  })
  }

  //const [loader, setLoader] = useState(false)
  const [dealSauceView, setDealSauceView] = useState('creative')
  const [openPITICashData, setOpenPITICashData] = useState(false)
  const [openPITICreativeData, setOpenPITICreativeData] =
    useState(false)

  const pitiTotal = getPitiTotal(property)
  const creativeEntryFee = getCreativeEntryFee(property)
  const cashEntryFee = getCashEntryFee(property)

  const [getFinancing, setGetFinancing] = useState(null)

  const toggleGetFinancing = (name) => {
    setGetFinancing(name)
  }

  const toggleGetFinancingClose = () => {
    setGetFinancing(null)
  }

  const basicAcquisitionFields = [
    {
      type: 'dollar',
      name: 'offerPrice',
      label: 'Purchase Price',
      tooltipButtonText: 'Show Purchase Price data',
      value:
        analysisInput.offerPrice === null
          ? //? analysisInput.listPrice.toString()
            ''
          : analysisInput.offerPrice.toString(),
      helper:
        !analysisInput.offerPrice || analysisInput.offerPrice === '0'
          ? '0% Discount to Price'
          : (
              (1 -
                analysisInput.offerPrice / analysisInput.listPrice) *
              100
            ).toFixed(0) + '% Discount to Price',
      xs: 12,
      lg: 6,
      definition: 'offerPrice',
      tooltipField:
        'The price that the seller is asking for this home. *Not necessarily the price that the investor will purchase the home for.',
      dataTour: 'acquisitionExpenses-step-4',
      dataTourDatabase: 'acquisitionExpenses-step-5',
    },
    {
      type: 'dollar',
      name: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueFixFlip'
        : 'afterRepairValue',
      label: 'After Repair Value',
      tooltipButtonText: 'Show ARV data',
      value: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? analysisInput.afterRepairValueFixFlip === null
          ? ''
          : analysisInput.afterRepairValueFixFlip.toString()
        : analysisInput.afterRepairValue === null
          ? ''
          : analysisInput.afterRepairValue.toString(),
      //helper: currencyFormat.format(analytics.fixFlip.equity) + ' in equity',
      xs: 12,
      lg: 6,
      definition: 'afterRepairValue',
      definitionTarget: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueFixFlip'
        : 'afterRepairValue',
      tooltipField:
        'The ARV is the value of a property after you have conducted repairs and are ready to sell',
      dataTour: 'acquisitionExpenses-step-6',
      dataTourDatabase: 'acquisitionExpenses-step-7',
    },
    {
      type: 'dropdown',
      name: 'closingCostFixFlip',
      value: assumptionsInput.closingCostFixFlip,
      label: 'Closing Cost',
      adornmentToggle: assumptionsInput.closingCostFixFlipType,
      adornment: assumptionsInput.closingCostFixFlipType,
      adornmentName: 'closingCostFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Fees (attorney/title fees, etc) Paid at Closing. Expressed as a dollar amount or precentage of the purchase prices.',
      dataTour: 'acquisitionExpenses-step-8',
    },
    {
      type: 'dollar',
      name: 'creditFromSeller',
      value: assumptionsInput.creditFromSeller,
      label: 'Credit From Seller',
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A seller credit is the dollar amount the seller will put towards your closing costs.',
      dataTour: 'acquisitionExpenses-step-9',
    },
  ]

  const advancedAcquisitionFields = [
    {
      type: 'dropdown',
      name: 'acquisitionCommission',
      label: 'Acq Commission',
      value: assumptionsInput.acquisitionCommission,
      adornmentToggle: assumptionsInput.acquisitionCommissionType,
      adornment: assumptionsInput.acquisitionCommissionType,
      adornmentName: 'acquisitionCommissionType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - Used in addition to sales of typical sales commissions expressed as a percentage of the Purchase price or a fixed dollar amount',
      dataTour: 'acquisitionExpenses-step-10',
    },
    {
      type: 'dollar',
      name: 'acquisitionFee',
      label: 'Acquisition Fee',
      value: assumptionsInput.acquisitionFee,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Advanced Fee - Used in addition to sales of typical sales commissions expressed as a fixed dollar amount.',
      dataTour: 'acquisitionExpenses-step-11',
    },
    // {
    //   type: 'percentage',
    //   name: 'assetManagementFee',
    //   label: 'Asset Mgmt Fee',
    //   value: assumptionsInput.assetManagementFee,
    //   xs: 6,
    //   assumptions: true,
    // },
    {
      type: 'dropdown',
      name: 'financingFeeFixFlip',
      label: 'Financing Fee',
      value: assumptionsInput.financingFeeFixFlip,
      adornment: assumptionsInput.financingFeeFixFlipType,
      adornmentToggle: assumptionsInput.financingFeeFixFlipType,
      adornmentName: 'financingFeeFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - A fee that the real estate professional charges for securing financing on the property. Expressed as a percentage of the loan amount.',
      dataTour: 'acquisitionExpenses-step-12',
    },
    {
      type: 'dollar',
      name: 'ownerReservesFixFlip',
      label: '1x Owner Reserve',
      value: assumptionsInput.ownerReservesFixFlip,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A single contribution of money paid shortly after closing to keep in the bank to be used for large future expenses (capex items, etc.)',
      dataTour: 'acquisitionExpenses-step-13',
    },
  ]

  const customAcquisitonField = [
    {
      type: 'budgetLines',
      name: 'customAcquisitionExpenses',
      value: analysisInput.customAcquisitionExpenses,
      label: 'Custom Acquisition Expenses',
      options: activeOrg.customAcquisitionExpenseTypes,
      xs: 12,
      optionName: 'customAcquisitionExpenseTypes',
      removeOption: true,
    },
  ]

  const uncheckAdvanced = every(
    advancedAcquisitionFields,
    (field) => !field.value,
  )

  const [state, setState] = React.useState({
    checkedA: !uncheckAdvanced,
    checkedB: false,
    checkedF: false,
    checkedG: false,
  })

  const acquisitionChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      [
        'Purchase Price',
        'Closing Costs',
        'Acquisition Commission',
        'Acquisition Fee',
        'Financing Fee',
        'One-time Owner Reserve',
      ],
      map(
        analysis.customAcquisitionExpenses,
        (expense) => expense.value,
      ),
    ),
    pieColors,
  )
  const acquisitionChartSeries = concat(
    [
      round(
        analysis.offerPrice === null
          ? analysis.listPrice
          : analysis.offerPrice,
        2,
      ) || 0.0001,
      round(analytics.fixFlip.closeCostDollarFixFlip, 2) || 0,
      round(analytics.acquisitionCommissionDollar, 2) || 0,
      round(assumptions.acquisitionFee, 2) || 0,
      round(analytics.fixFlip.financingFeeTotalFixFlip, 2) || 0,
      round(assumptions.ownerReservesFixFlip, 2) || 0,
    ],
    map(
      analysis.customAcquisitionExpenses,
      (expense) => round(expense.value, 2) || 0,
    ),
  )

  let grossMonthlyIncomeSingleRentFields = filter(
    [
      {
        type: 'select',
        name: 'rentType',
        label: 'Rent Type',
        value: assumptionsInput.rentType,
        options: assumptionsOptions(activeOrg)?.rentTypes,
        xs: 12,
        lg: 12,
        assumptions: true,
        dataTour: 'grossMonthlyIncomeSingleRent-step-2',
      },
      {
        type: 'dollar',
        name: `rent.${props.activeUnit}`,
        label: 'Total Rental Income',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rent[props.activeUnit] === null
            ? ''
            : analysisInput.rent[props.activeUnit].toString(),
        helper:
          property.sqft &&
          property.sqft[props.activeUnit] &&
          analysisInput.rent[props.activeUnit]
            ? currencyFormat2.format(
                analysisInput.rent[props.activeUnit] /
                  property.sqft[props.activeUnit],
              ) + ' rent per sqft'
            : '$0.00 rent per sqft',
        xs: 12,
        lg: 6,
        definition: 'rent',
        // disabled: !isNil(analysisInput.ownerOccupiedFixFlip) && props.activeUnit === analysisInput.ownerOccupiedFixFlip,
        tooltipField:
          "A tenant's monthly payment to a landlord for the use of property or land.",
        hide: assumptionsInput.rentType !== 'singleRent',
        dataTour: 'grossMonthlyIncomeSingleRent-step-3',
        dataTourDatabase: 'grossMonthlyIncomeSingleRent-step-4',
      },
      {
        type: 'percentage',
        name: `vacancy.${props.activeUnit}`,
        label: 'Vacancy Rate',
        value: assumptionsInput.vacancy[props.activeUnit],
        xs: 12,
        lg: 6,
        assumptions: true,
        tooltipField:
          'The percentage of time that a property is not rented out during the course of a year.',
        homeType: 'both',
        dataTour: 'grossMonthlyIncomeSingleRent-step-5',
      },
      {
        type: 'dollar',
        name: `otherIncome.${props.activeUnit}`,
        label: 'Other Monthly Income',
        value:
          analysisInput.otherIncome[props.activeUnit] === null
            ? ''
            : analysisInput.otherIncome[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        tooltipField:
          'Additional income you earn through the property. Some examples might be coin-op laundry, parking, storage, etc.',
        homeType: 'both',
        dataTour: 'grossMonthlyIncomeSingleRent-step-6',
      },
    ],
    (field) => !field.hide,
  )

  // if (analysisInput.rent.length > 1) {
  //   grossMonthlyIncomeSingleRentFields.push({
  //     type: 'checkbox',
  //     label: 'Owner Occupied',
  //     name: 'ownerOccupiedFixFlip',
  //     value: !isNil(analysisInput.ownerOccupiedFixFlip) && analysisInput.ownerOccupiedFixFlip === props.activeUnit,
  //     xs: 12,
  //     lg: 6,
  //     tooltipField: 'This unit is occupied by the owner',
  //   })
  // }

  let grossMonthlyIncomeRentRangeFields = filter(
    [
      {
        type: 'select',
        name: 'rentType',
        label: 'Rent Type',
        value: assumptionsInput.rentType,
        options: assumptionsOptions(activeOrg)?.rentTypes,
        xs: 12,
        lg: 12,
        assumptions: true,
        dataTour: 'grossMonthlyIncomeRentRange-step-2',
      },
      // {
      //   type: 'dollar',
      //   name: `rent.${props.activeUnit}`,
      //   label: 'Total Rental Income',
      //   tooltipButtonText: 'Show Total Rent data',
      //   value:
      //     analysisInput.rent[props.activeUnit] === null
      //       ? ''
      //       : analysisInput.rent[props.activeUnit].toString(),
      //   helper: property.sqft && property.sqft[props.activeUnit] && analysisInput.rent[props.activeUnit] ? currencyFormat2.format(analysisInput.rent[props.activeUnit] / property.sqft[props.activeUnit]) + ' rent per sqft' : '$0.00 rent per sqft',
      //   xs: 12,
      //   lg: 6,
      //   definition: 'rent',
      //   disabled: !isNil(analysisInput.ownerOccupied) && props.activeUnit === analysisInput.ownerOccupied,
      //   tooltipField: "A tenant's monthly payment to a landlord for the use of property or land.",
      //   hide: assumptionsInput.rentType !== 'singleRent',
      //   dataTour: "grossMonthlyIncome-step-1",
      // },
      {
        type: 'dollar',
        name: `rentLow.${props.activeUnit}`,
        label: 'Rent Range Low',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentLow[props.activeUnit] === null
            ? ''
            : analysisInput.rentLow[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Lower end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: 'grossMonthlyIncomeRentRange-step-3',
        dataTourDatabase: 'grossMonthlyIncomeRentRange-step-4',
      },
      {
        type: 'dollar',
        name: `rentHigh.${props.activeUnit}`,
        label: 'Rent Range High',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentHigh[props.activeUnit] === null
            ? ''
            : analysisInput.rentHigh[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Higher end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: 'grossMonthlyIncomeRentRange-step-5',
        dataTourDatabase: 'grossMonthlyIncomeRentRange-step-6',
      },
      {
        type: 'percentage',
        name: `vacancy.${props.activeUnit}`,
        label: 'Vacancy Rate',
        value: assumptionsInput.vacancy[props.activeUnit],
        xs: 12,
        lg: 6,
        assumptions: true,
        tooltipField:
          'The percentage of time that a property is not rented out during the course of a year.',
        homeType: 'both',
        dataTour: 'grossMonthlyIncomeRentRange-step-7',
      },
      {
        type: 'dollar',
        name: `otherIncome.${props.activeUnit}`,
        label: 'Other Monthly Income',
        value:
          analysisInput.otherIncome[props.activeUnit] === null
            ? ''
            : analysisInput.otherIncome[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        tooltipField:
          'Additional income you earn through the property. Some examples might be coin-op laundry, parking, storage, etc.',
        homeType: 'both',
        dataTour: 'grossMonthlyIncomeRentRange-step-8',
      },
    ],
    (field) => !field.hide,
  )

  // if (analysisInput.rent.length > 1) {
  //   grossMonthlyIncomeRentRangeFields.push({
  //     type: 'checkbox',
  //     label: 'Owner Occupied',
  //     name: 'ownerOccupiedFixFlip',
  //     value: !isNil(analysisInput.ownerOccupiedFixFlip) && analysisInput.ownerOccupiedFixFlip === props.activeUnit,
  //     xs: 12,
  //     lg: 6,
  //     tooltipField: 'This unit is occupied by the owner',
  //     dataTour: "grossMonthlyIncomeRentRange-step-9",
  //   })
  // }

  const grossMonthlyIncomeChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      map(
        analytics.grossAnnualRent,
        (value, index) => `Unit ${index + 1} Monthly Rental Income`,
      ),
      map(
        analysis.otherIncome,
        (value, index) => `Unit ${index + 1} Other Monthly Income`,
      ),
    ),
    pieColors,
  )
  const grossMonthlyIncomeChartSeries = concat(
    map(
      analytics.grossAnnualRent,
      (grossAnnualRent, index) =>
        round(grossAnnualRent / 12, 2) || (index === 0 ? 0.0001 : 0),
    ),
    map(
      analysis.otherIncome,
      (otherIncome) => round(otherIncome, 2) || 0,
    ),
  )

  const gorillaRehabDays = isNil(analysisInput.rehabDays)
    ? analysisInput.rehabCost / 500 + 55
    : analysisInput.rehabDays
  const gorillaFee =
    ((analysisInput.offerPrice === null
      ? analysisInput.listPrice
      : analysisInput.offerPrice) +
      analysisInput.rehabCostFixFlip) *
    0.0005 *
    gorillaRehabDays
  const gorillaMinFee =
    (analysisInput.offerPrice === null
      ? analysisInput.listPrice
      : analysisInput.offerPrice) > 100000
      ? (analysisInput.offerPrice === null
          ? analysisInput.listPrice
          : analysisInput.offerPrice) * 0.06
      : 6000
  const gorillaFinalFee =
    gorillaFee > gorillaMinFee ? gorillaFee : gorillaMinFee
  const gorillaSplit =
    gorillaRehabDays <= 30
      ? 0.05
      : gorillaRehabDays <= 60
        ? 0.1
        : gorillaRehabDays <= 90
          ? 0.2
          : gorillaRehabDays <= 120
            ? 0.3
            : 0.4

  // const rehabCard =
  //   find(
  //     cards,
  //     (card) =>
  //       card.name === 'rehab' && card.member === activeOrg.member,
  //   ) ||
  //   find(
  //     cards,
  //     (card) => card.name === 'rehab' && card.member === null,
  //   ) ||
  //   {}
  // const rehabFields = filter(
  //   map(get(rehabCard, 'card.fields'), (field) => {
  //     const input = field.analytics
  //       ? analytics.fixFlip
  //       : field.assumptions
  //       ? assumptionsInput
  //       : analysisInput
  //     const options =
  //       field.options && field.assumptions
  //         ? get(assumptionsOptions(activeOrg), field.options) ||
  //           get(activeOrg, field.options) ||
  //           field.options
  //         : get(activeOrg, field.options) || field.options
  //     const memberOptions =
  //       field.memberOptions && field.assumptions
  //         ? get(assumptionsOptions(activeOrg), field.memberOptions) ||
  //           get(activeOrg, field.memberOptions)
  //         : get(activeOrg, field.memberOptions)
  //     const name = field.suffix
  //       ? includes(field.name, 'Type')
  //         ? replace(field.name, 'Type', 'FixFlipType')
  //         : field.name + 'FixFlip'
  //       : field.name
  //     const hide =
  //       field.suffix && field.hide
  //         ? includes(field.hide, 'Type')
  //           ? replace(field.hide, 'Type', 'FixFlipType')
  //           : field.hide + 'FixFlip'
  //         : field.hide
  //     const adornmentName =
  //       field.suffix && field.adornmentName
  //         ? includes(field.adornmentName, 'Type')
  //           ? replace(field.adornmentName, 'Type', 'FixFlipType')
  //           : field.adornmentName + 'FixFlip'
  //         : field.adornmentName
  //     const definition =
  //       field.suffix && field.definition
  //         ? includes(field.definition, 'Type')
  //           ? replace(field.definition, 'Type', 'FixFlipType')
  //           : field.definition + 'FixFlip'
  //         : field.definition

  //     const helper = includes(field.name, 'rehabTier')
  //       ? currencyFormat.format(
  //           (field.value ? eval(field.value) : get(input, name)) *
  //             (assumptionsInput.percentageOfARVFixFlip / 100) *
  //             propertyInput.sqft,
  //         ) + ' Total'
  //       : null
  //     return {
  //       ...field,
  //       name,
  //       value: field.value ? eval(field.value) : get(input, name),
  //       adornmentToggle: get(input, adornmentName),
  //       adornment: get(input, adornmentName),
  //       definition: definition,
  //       options: filter(
  //         options,
  //         (option) =>
  //           isEmpty(option.showMarkets) ||
  //           includes(option.showMarkets, analysisInput.marketType),
  //       ),
  //       memberOptions: filter(
  //         memberOptions,
  //         (option) =>
  //           isEmpty(option.showMarkets) ||
  //           includes(option.showMarkets, analysisInput.marketType),
  //       ),
  //       helper,
  //       hide,
  //     }
  //   }),
  //   (field) => !field.hide || !eval(field.hide),
  // )

  const rehabFields = filter(
    [
      {
        type: 'select',
        name: 'rehabFixFlipType',
        value: assumptionsInput.rehabFixFlipType,
        label: 'Rehab Type',
        xs: 12,
        options: assumptionsOptions(activeOrg)?.rehabOptions,
        assumptions: true,
      },
      {
        type: 'dollar',
        name: 'rehabCostFixFlip',
        value: analysisInput.rehabCostFixFlip,
        label: 'Est Rehab',
        tooltipButtonText: 'Show Estimated Rehab data',
        xs: 12,
        lg: 6,
        definition: 'rehabCostFixFlip',
        tooltipField:
          'An expense that is incurred when restoring an entity to its normal or near-normal condition.',
        hide:
          assumptionsInput.rehabFixFlipType !== 'singleRehabValue',
        dataTour: 'rehabExpenses-step-1',
      },
      {
        type: 'budgetLines',
        name: 'detailedRehabCostFixFlip',
        value: analysisInput.detailedRehabCostFixFlip,
        label: 'Rehab Costs',
        xs: 12,
        options: [
          'Appliances',
          'Cabinets/Vanities',
          'Carpet',
          'Countertops/Sinks/Toilets',
          'Driveway/Decking/Patio',
          'Electrical',
          'Exterior',
          'Flooring',
          'Framing',
          'Insulation/Drywall',
          'Landscaping',
          'Masonry',
          'Mechanical',
          'Molding/Tile/Trim',
          'Paint',
          'Plans/Permits',
          'Plumbing',
          'Roof',
          'Siding/Gutters',
          'Site Prep',
          'Staging',
          'Windows/Doors',
          'Other',
        ],
        hide: assumptionsInput.rehabFixFlipType !== 'detailedRehab',
        dataTour: 'rehabExpenses-step-1',
      },
      {
        type: 'rehabCalc',
        name: 'rehabCalcTotalFixFlip',
        label: 'Rehab Calculator',
        value: analysisInput.rehabCalcTotalFixFlip,
        xs: 12,
        lg: 6,
        property: property,
        assumptionsInput: assumptionsInput,
        affiliate: props.affiliate,
        hide: assumptionsInput.rehabFixFlipType !== 'rehabCalc',
        dataTour: 'rehabExpenses-step-1',
      },
      {
        type: 'select',
        name: 'rehabTierFixFlip',
        value: assumptionsInput.rehabTierFixFlip,
        label: 'Rehab Tier',
        tooltipButtonText: 'Show Estimated Rehab data',
        xs: 12,
        lg: 6,
        options: filter(
          activeOrg.rehabTiers,
          (option) =>
            isEmpty(option.showMarkets) ||
            includes(
              option.showMarkets,
              analysisInput.marketType ||
                props.affiliate?.defaultMarketType,
            ),
        ),
        optionName: 'rehabTiers',
        memberOptions: filter(
          activeOrg.memberRehabTiers,
          (option) =>
            isEmpty(option.showMarkets) ||
            includes(
              option.showMarkets,
              analysisInput.marketType ||
                props.affiliate?.defaultMarketType,
            ),
        ),
        dynamicMemberOptions: map(
          filter(
            activeOrg.dynamicMemberRehabTiers,
            (option) =>
              isEmpty(option.showMarkets) ||
              includes(
                option.showMarkets,
                analysisInput.marketType ||
                  props.affiliate?.defaultMarketType,
              ),
          ),
          (option) => {
            let breakPointIndex = 0
            const arv = includes(
              assumptionsInput.strategySpecificFields,
              'afterRepairValue',
            )
              ? analysisInput.afterRepairValueFixFlip === null
                ? null
                : analysisInput.afterRepairValueFixFlip
              : analysisInput.afterRepairValue === null
                ? null
                : analysisInput.afterRepairValue
            while (
              option?.breakpoints[breakPointIndex] < arv &&
              breakPointIndex < option?.breakpoints.length
            ) {
              breakPointIndex++
            }
            return {
              ...option,
              label: `$${option.values[breakPointIndex]}/Sqft`,
            }
          },
        ),
        removeOption: true,
        assumptions: true,
        hide:
          assumptionsInput.rehabFixFlipType !== 'rehabTier' &&
          assumptionsInput.rehabFixFlipType !==
            'flippingAmericaRehab',
        dataTour: 'rehabExpenses-step-1',
        helper: currencyFormat.format(
          analytics.fixFlip.rehabTierValueFixFlip,
        ),
      },
      {
        name: 'marketType',
        value: !analysisInput.marketType
          ? props.affiliate?.defaultMarketType
          : analysisInput.marketType,
        label: 'Market Type',
        options: concat(
          [props.affiliate?.defaultMarketType],
          props.affiliate?.marketTypes,
        ),
        type: 'select',
        xs: 12,
        lg: 6,
        hide:
          isEmpty(props.affiliate?.marketTypes) ||
          (assumptionsInput.rehabFixFlipType !== 'rehabTier' &&
            assumptionsInput.rehabFixFlipType !==
              'flippingAmericaRehab'),
      },
      {
        type: 'dollar',
        name: 'rehabDecadeCostFixFlip',
        value: assumptionsInput.rehabDecadeCostFixFlip,
        label: 'Rehab Per Decade',
        xs: 12,
        lg: 6,
        assumptions: true,
        hide:
          assumptionsInput.rehabFixFlipType !==
          'flippingAmericaRehab',
      },
      {
        type: 'number',
        name: 'rehabDays',
        label: 'Est Hold Time (days)',
        value:
          analysisInput.rehabDays === null ||
          analysisInput.rehabDays === undefined
            ? analysisInput.rehabCost === null
              ? ''
              : analysisInput.rehabCost / 500
            : analysisInput.rehabDays,
        xs: 12,
        lg: 6,
        tooltipField: '',
        hide: activeOrg.member !== 'gorillacapital',
      },
      {
        type: 'dollar',
        name: 'gorillaFee',
        label: 'Gorilla Fee',
        value: gorillaFinalFee,
        xs: 12,
        lg: 6,
        disabled: true,
        tooltipField: '',
        hide: activeOrg.member !== 'gorillacapital',
      },
      {
        type: 'dollar',
        name: 'gorillaBuyBox',
        label: 'Gorilla Buy Box',
        value:
          analysisInput.afterRepairValue * 0.75 -
          analysisInput.rehabCost,
        xs: 12,
        lg: 6,
        disabled: true,
        tooltipField: '',
        hide: activeOrg.member !== 'gorillacapital',
      },
      {
        type: 'dollar',
        name: 'myProfit',
        label: 'My Profit',
        value:
          analytics.fixFlip.saleProceeds * gorillaSplit <
          gorillaFinalFee
            ? analytics.fixFlip.saleProceeds - gorillaFinalFee
            : analytics.fixFlip.saleProceeds * (1 - gorillaSplit),
        xs: 12,
        lg: 6,
        disabled: true,
        tooltipField: '',
        hide: activeOrg.member !== 'gorillacapital',
      },
      {
        type: 'dollar',
        name: 'Gorilla Profit',
        label: 'Gorilla Profit',
        value:
          analytics.fixFlip.saleProceeds * gorillaSplit <
          gorillaFinalFee
            ? 0
            : analytics.saleProceeds * gorillaSplit - gorillaFinalFee,
        xs: 12,
        lg: 6,
        disabled: true,
        tooltipField: '',
        hide: activeOrg.member !== 'gorillacapital',
      },
      {
        type: 'percentage',
        name: 'rehabContingencyFixFlip',
        value: assumptionsInput.rehabContingencyFixFlip,
        adornmentToggle: assumptionsInput.rehabContingencyFixFlipType,
        adornment: assumptionsInput.rehabContingencyFixFlipType,
        adornmentName: 'rehabContingencyFixFlipType',
        helper:
          assumptionsInput.rehabContingencyFixFlipType === '%'
            ? currencyFormat.format(
                assumptionsInput.rehabTierFixFlip *
                  property.sqft *
                  (assumptionsInput.rehabContingencyFixFlip / 100),
              )
            : null,
        label: 'Rehab Contingency',
        xs: 12,
        lg: 6,
        assumptions: true,
        dropdown: true,
        tooltipField:
          'Percentage of calculated rehab cost added as a saftey margin',
        // dataTour: "wholesaleDetails-step-5"
      },
    ],
    (field) => !field.hide,
  )

  const rehabChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      assumptionsInput.rehabFixFlipType === 'detailedRehab'
        ? isEmpty(analysis.detailedRehabCostFixFlip)
          ? ['Total Rehab']
          : map(
              analysis.detailedRehabCostFixFlip,
              (line) => line.type || 'Unlabeled',
            )
        : ['Total Rehab'],
      activeOrg.member === 'gorillacapital' ? ['Gorilla Fee'] : [],
    ),
    pieColors,
  )
  const rehabChartSeries = concat(
    assumptionsInput.rehabFixFlipType === 'detailedRehab'
      ? isEmpty(analysis.detailedRehabCostFixFlip)
        ? [0.0001]
        : map(analysis.detailedRehabCostFixFlip, (line, index) =>
            index === 0
              ? round(line.value, 2) || 0.0001
              : round(line.value, 2) || 0,
          )
      : [round(analytics.fixFlip.corTotalFixFlip, 2) || 0.0001],
    activeOrg.member === 'gorillacapital'
      ? [round(gorillaFinalFee, 2) || 0]
      : [],
  )

  const holdingExpensesFields = [
    {
      dropdown: true,
      type: 'dropdown',
      name: 'propertyInsuranceFixFlip',
      label: 'Annual Insurance',
      value: assumptionsInput.propertyInsuranceFixFlip,
      adornmentToggle: assumptionsInput.propertyInsuranceFixFlipType,
      adornment: assumptionsInput.propertyInsuranceFixFlipType,
      adornmentName: 'propertyInsuranceFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Annual property insurance premium expressed as a dollar amount or percentage of the purchase price',
      dataTour: 'holdingExpenses-step-2',
    },
    {
      dropdown: true,
      type: 'dropdown',
      name: 'propertyManagementFixFlip',
      label: 'Property Mgmt Fee',
      value: assumptionsInput.propertyManagementFixFlip,
      adornmentToggle: assumptionsInput.propertyManagementFixFlipType,
      adornment: assumptionsInput.propertyManagementFixFlipType,
      adornmentName: 'propertyManagementFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Annual property insurance premium expressed as a dollar amount or percentage of the purchase price',
    },
    {
      dropdown: true,
      type: 'dropdown',
      name: 'HOA',
      label: 'HOA',
      value: analysisInput.HOA,
      adornmentToggle: analysisInput.HOAType,
      adornment: analysisInput.HOAType,
      adornmentName: 'HOAType',
      xs: 12,
      lg: 6,
      tooltipField:
        'An organization in a subdivision, planned community, or condominium building that makes and enforces rules for the properties and its residents. These residents automatically become members and are required to pay dues, known as HOA fees.',
      dataTour: 'holdingExpenses-step-3',
    },
    {
      type: 'dollar',
      name: 'propertyTaxes',
      label: 'Property Taxes',
      tooltipButtonText: 'Show Property Tax data',
      value:
        analysisInput.propertyTaxes === null
          ? ''
          : analysisInput.propertyTaxes.toString(),
      xs: 12,
      lg: 6,
      definition: 'propertyTaxes',
      tooltipField:
        'A tax paid on property owned by an individual or other legal entity, such as a corporation.',
      dataTour: 'holdingExpenses-step-4',
      dataTourDatabase: 'holdingExpenses-step-5',
    },
    {
      type: 'dropdown',
      name: 'utilitiesFixFlip',
      label: 'Monthly Utilities',
      value: assumptionsInput.utilitiesFixFlip,
      adornmentToggle: assumptionsInput.utilitiesFixFlipType,
      adornment: assumptionsInput.utilitiesFixFlipType,
      adornmentName: 'utilitiesFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Includes electricity, water, sewer, gas, garbage, etc.  Expressed as a dollar amount or a percentage of Monthly Gross Rental Income (rent - vacancy).',
      dataTour: 'holdingExpenses-step-6',
    },
    {
      type: 'percentage',
      name: 'maintenanceFixFlip',
      label: 'Annual Maintenance',
      value: assumptionsInput.maintenanceFixFlip,
      adornmentToggle: assumptionsInput.maintenanceFixFlipType,
      adornment: assumptionsInput.maintenanceFixFlipType,
      adornmentName: 'maintenanceFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The annual cost of maintenance repairs to the property expressed as a percentage of Gross Rental Income (rent - vacancy).',
      dataTour: 'holdingExpenses-step-7',
    },
    {
      dropdown: true,
      type: 'dropdown',
      name: 'monthlyReservesFixFlip',
      label: 'Capex (reserve/mo)',
      value: assumptionsInput.monthlyReservesFixFlip,
      adornment: assumptionsInput.monthlyReservesFixFlipType,
      adornmentToggle: assumptionsInput.monthlyReservesFixFlipType,
      adornmentName: 'monthlyReservesFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of monthly income you want to put aside each month as a reserve for future expenses.  This includes capital expenditure (capex) items such as the roof, appliances, water, heater, etc. Expressed as a dollar amount or a percentage of Monthly Gross Rental Income (rent - vacancy).',
    },
    {
      type: 'dollar',
      name: 'otherExpenseFixFlip',
      label: 'Other Expenses / yr',
      value:
        assumptionsInput.otherExpenseFixFlip === null
          ? ''
          : assumptionsInput.otherExpenseFixFlip.toString(),
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Any annual expense that has not already been labeled.',
      dataTour: 'holdingExpenses-step-8',
    },
    {
      type: 'dollar',
      name: 'mortgageFixFlip',
      label: 'Monthly Mortgage',
      value:
        analytics.fixFlip.mortgageFixFlip === null
          ? ''
          : analytics.fixFlip.mortgageFixFlip,
      xs: 12,
      lg: 6,
      disabled: true,
      tooltipField: `The amount you pay every month toward your mortgage loan. This field is not editable. To change your mortgage amount, see the Financing card below.`,
      dataTour: 'holdingExpenses-step-9',
    },
    {
      type: 'number',
      name: 'holdingPeriod',
      label: 'Holding Period (months)',
      value: assumptionsInput.holdingPeriod,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A holding period is the amount of time the investment is held by an investor or the period between the purchase and sale of the property. Expressed in months.',
      dataTour: 'holdingExpenses-step-10',
    },
    {
      type: 'budgetLines',
      name: 'customMonthlyExpenses',
      label: 'Custom Monthly Expenses',
      value: analysisInput.customMonthlyExpenses,
      xs: 12,
      options: activeOrg.customMonthlyExpenseTypes,
      optionName: 'customMonthlyExpenseTypes',
      removeOption: true,
    },
  ]

  const holdingExpensesChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      [
        'Property Insurance',
        'Property Mgmt Fee',
        'HOA',
        'Property Taxes',
        'Maintenance',
        'Utilities',
        'Capex',
        'Other Expenses',
        'Mortgage',
      ],
      map(analysis.customMonthlyExpenses, (expense) => expense.type),
    ),
    pieColors,
  )
  const holdingExpensesChartSeries = concat(
    [
      round(
        (analytics.fixFlip.propertyInsuranceDollarFixFlip / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0.0001,
      round(
        (analytics.fixFlip.propertyManagementDollarFixFlip / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        (analytics.fixFlip.hoaTotal / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        (analysis.propertyTaxes / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        (analytics.fixFlip.maintenanceFixFlipDollar / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        analytics.fixFlip.utilitiesTypeDollarFixFlip *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        analytics.fixFlip.monthlyReservesTypeDollarFixFlip *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        (assumptions.otherExpenseFixFlip / 12) *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
      round(
        analytics.fixFlip.mortgageFixFlip *
          assumptionsInput.holdingPeriod,
        2,
      ) || 0,
    ],
    map(
      analysis.customMonthlyExpenses,
      (expense) =>
        round(expense.value * assumptionsInput.holdingPeriod, 2) || 0,
    ),
  )

  const financingFields = activeOrg.isRealeflow
    ? [
        {
          type: 'checkbox',
          label: 'Cash Purchase',
          name: 'allCashPurchaseFixFlip',
          value: assumptionsInput.allCashPurchaseFixFlip,
          xs: 12,
          assumptions: true,
          tooltipField:
            'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
          dataTour: 'financing-step-4',
        },
        {
          type: 'percentage',
          name: 'percentageOfPurchase',
          label: '% of Purchase Price',
          value: 100 - assumptionsInput.downPaymentFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'The percentage of the purchase price that is being covered by the loan',
          dataTour: 'financing-step-5',
        },
        {
          type: 'percentage',
          name: 'financingRepairsPercentageFixFlip',
          label: '% of Rehab',
          value: analysisInput.financingRepairsPercentageFixFlip || 0,
          xs: 12,
          lg: 6,
          tooltipField:
            'The percentage of the repair cost that is being covered by the loan',
          dataTour: 'financing-step-10',
        },
        {
          type: 'percentage',
          name: 'rateFixFlip',
          label: 'Interest Rate',
          value: assumptionsInput.rateFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
          dataTour: 'financing-step-6',
        },
        {
          type: 'dropdown',
          name: 'termFixFlip',
          label: 'Financing Term',
          value: assumptionsInput.termFixFlip,
          adornment: assumptionsInput.termFixFlipType,
          adornmentToggle: assumptionsInput.termFixFlipType,
          adornmentName: 'termFixFlipType',
          xs: 12,
          lg: 6,
          assumptions: true,
          dropdown: true,
          tooltipField:
            'The length of time that the loan is being amortized. Expressed in months or years.',
          dataTour: 'financing-step-7',
        },
        {
          type: 'number',
          name: 'pointsFixFlip',
          label: 'Points',
          value: assumptionsInput.pointsFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
          dataTour: 'financing-step-8',
        },
        {
          type: 'dropdown',
          name: 'financingFeeFixFlip',
          label: 'Financing Fee',
          value: assumptionsInput.financingFeeFixFlip,
          adornment: assumptionsInput.financingFeeFixFlipType,
          adornmentToggle: assumptionsInput.financingFeeFixFlipType,
          adornmentName: 'financingFeeFixFlipType',
          xs: 12,
          lg: 6,
          assumptions: true,
          dropdown: true,
          tooltipField:
            'A fee that the real estate professional charges for securing financing on the property. Expressed as a percentage of the loan amount.',
        },
        {
          name: 'lender',
          value: analysisInput.lender || '',
          label: 'Lender',
          options: filter(activeOrg.lenders, (lender) =>
            isEmpty(lender.type),
          ),
          optionName: 'lenders',
          removeOption: true,
          type: 'select',
          xs: 12,
          lg: 6,
        },
        {
          type: 'checkbox',
          name: 'interestOnlyLoanFixFlip',
          label: 'Interest Only Loan',
          value: assumptionsInput.interestOnlyLoanFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'A loan that only requires the payment of interest, not principal.',
          dataTour: 'financing-step-9',
        },
        // {
        //   type: 'checkbox',
        //   name: 'financingRepairsFixFlip',
        //   label: 'Finance Repairs',
        //   value: analysisInput.financingRepairsFixFlip || false,
        //   xs: 12,
        //   lg: 6,
        //   tooltipField: 'Checking this will include the repair costs into your loan',
        //   dataTour: 'financing-step-10'
        // },
      ]
    : [
        {
          type: 'checkbox',
          label: 'Cash Purchase',
          name: 'allCashPurchaseFixFlip',
          value: assumptionsInput.allCashPurchaseFixFlip,
          xs: 12,
          assumptions: true,
          tooltipField:
            'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
          dataTour: 'financing-step-4',
        },
        {
          type: 'percentage',
          name: 'downPaymentFixFlip',
          label: 'Down Payment',
          value: assumptionsInput.downPaymentFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
          dataTour: 'financing-step-5',
        },
        {
          type: 'percentage',
          name: 'financingRepairsPercentageFixFlip',
          label: '% of Rehab',
          value: analysisInput.financingRepairsPercentageFixFlip || 0,
          xs: 12,
          lg: 6,
          tooltipField:
            'The percentage of the repair cost that is being covered by the loan',
          dataTout: 'financing-step-10',
        },
        {
          type: 'percentage',
          name: 'rateFixFlip',
          label: 'Interest Rate',
          value: assumptionsInput.rateFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
          dataTour: 'financing-step-6',
        },
        {
          type: 'dropdown',
          name: 'termFixFlip',
          label: 'Financing Term',
          value: assumptionsInput.termFixFlip,
          adornment: assumptionsInput.termFixFlipType,
          adornmentToggle: assumptionsInput.termFixFlipType,
          adornmentName: 'termFixFlipType',
          xs: 12,
          lg: 6,
          assumptions: true,
          dropdown: true,
          tooltipField:
            'The length of time that the loan is being amortized. Expressed in months or years.',
          dataTour: 'financing-step-7',
        },
        {
          type: 'number',
          name: 'pointsFixFlip',
          label: 'Points',
          value: assumptionsInput.pointsFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
          dataTour: 'financing-step-8',
        },
        {
          type: 'checkbox',
          name: 'interestOnlyLoanFixFlip',
          label: 'Interest Only Loan',
          value: assumptionsInput.interestOnlyLoanFixFlip,
          xs: 12,
          lg: 6,
          assumptions: true,
          tooltipField:
            'A loan that only requires the payment of interest, not principal.',
          dataTour: 'financing-step-9',
        },
        // {
        //   type: 'checkbox',
        //   name: 'financingRepairsFixFlip',
        //   label: 'Finance Repairs',
        //   value: analysisInput.financingRepairsFixFlip || false,
        //   xs: 12,
        //   lg: 6,
        //   tooltipField: 'Checking this will include the repair costs into your loan',
        //   dataTour: 'financing-step-10'
        // },
      ]

  const dispositionFields = [
    {
      type: 'dollar',
      name: 'resellPriceFixFlip',
      label: 'Resale Price',
      value:
        analysisInput.resellPriceFixFlip === null
          ? ''
          : analysisInput.resellPriceFixFlip.toString(),
      xs: 12,
      lg: 6,
      tooltipField:
        'The price you would sell the property for once the rehab is completed.',
      dataTour: 'dispositionExpenses-step-2',
    },
    {
      type: 'dropdown',
      name: 'sellerClosingCostFixFlip',
      label: 'Seller Closing Cost',
      value: assumptionsInput.sellerClosingCostFixFlip,
      adornmentToggle: assumptionsInput.sellerClosingCostFixFlipType,
      adornment: assumptionsInput.sellerClosingCostFixFlipType,
      adornmentName: 'sellerClosingCostFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Closing Costs Paid by the Seller. Expressed as a dollar amount or percentage of the resale price',
      dataTour: 'dispositionExpenses-step-3',
    },
    {
      type: 'dropdown',
      name: 'salesCommissionFixFlip',
      label: 'Sales Commission',
      value: assumptionsInput.salesCommissionFixFlip,
      adornmentToggle: assumptionsInput.salesCommissionFixFlipType,
      adornment: assumptionsInput.salesCommissionFixFlipType,
      adornmentName: 'salesCommissionFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Sales Commission on the Future Sale of Property. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-4',
    },
    {
      type: 'dropdown',
      name: 'dispositionFeeFixFlip',
      label: 'Disposition Fee',
      value: assumptionsInput.dispositionFeeFixFlip,
      adornmentToggle: assumptionsInput.dispositionFeeFixFlipType,
      adornment: assumptionsInput.dispositionFeeFixFlipType,
      adornmentName: 'dispositionFeeFixFlipType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - Additional marketing fee on top of sales commission. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-5',
    },
    {
      type: 'percentage',
      name: 'homePriceAppreciation',
      label: 'Home Price Appreciation',
      value: assumptionsInput.homePriceAppreciation,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % of Appreciation in Total Dollar Value that the Home has gained or lost each year. Expressed as a percentage of ARV (after repair value). If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-6',
    },
    {
      type: 'percentage',
      name: 'growthRateExpense',
      label: 'Expense Growth Rate',
      value: assumptionsInput.growthRateExpense,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % increase in property expenses per year. Expressed as a percentage of gross rental income. If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-7',
    },
    {
      type: 'dollar',
      name: 'loanBalanceAtHoldingPeriod',
      label: 'Loan Balance at Resale',
      value:
        analytics.fixFlip.loanBalanceAtHoldingPeriod === null
          ? ''
          : analytics.fixFlip.loanBalanceAtHoldingPeriod,
      xs: 12,
      lg: 6,
      disabled: true,
      tooltipField:
        'This field is not editable. The remaining loan amount at the end of your flip holding period.',
      dataTour: 'dispositionExpenses-step-8',
    },
  ]

  const dispositionChartOptions = createDonutChartOptions(
    currencyFormat,
    [
      'Seller Closing Cost',
      'Sales Commission',
      'Disposition Fee',
      'Loan Balance at Resale',
    ],
    pieColors,
  )

  const dispositionChartSeries = [
    round(analytics.fixFlip.sellingClosingCostDollarFixFlip, 2) ||
      0.0001,
    round(analytics.fixFlip.salesCommissionTotalFixFlip, 2) || 0,
    round(analytics.fixFlip.dispositionFeeDollarFixFlip, 2) || 0,
    round(analytics.fixFlip.loanBalanceAtHoldingPeriod, 2) || 0,
  ]

  const chartOptions = createBasicChartOptions(currencyFormat)
  const chartSeries = [
    {
      data: [
        round(analysis.resellPriceFixFlip) || 0,
        round(
          (analytics?.fixFlip?.totalOutOfPocketFixFlip || 0) +
            //+ sum(holdingExpensesChartSeries)  ##SPECIFIC COMMENT: holding expenses are part of the sellingTotalOutOfPocket
            //+ analytics.fixFlip.closeCostDollarFixFlip
            (analytics?.fixFlip?.salesCommissionTotalFixFlip || 0) +
            (analytics?.fixFlip?.dispositionFeeDollarFixFlip || 0) +
            (analytics?.fixFlip?.loanBalanceAtHoldingPeriod || 0),
        ) || 0,
        round(analytics?.fixFlip?.saleProceeds) || 0,
      ],
      // colors: [
      //   ranges: [
      //     {
      //       from: 100,
      //       to: 0,
      //       color: '#f83145',
      //     },
      //   ],
      // ],
    },
  ]

  //The investor's profit should be $25,000 OR 10% of the ARV, Whichever is greater.
  const higherPepProfit =
    analytics.fixFlip.arvTotalFixFlip * 0.1 > 25000
      ? analytics.fixFlip.arvTotalFixFlip * 0.1
      : 25000

  const pepMaxOfferPrice = Math.max(
    (includes(
      assumptionsInput.strategySpecificFields,
      'afterRepairValue',
    )
      ? analysisInput.afterRepairValueFixFlip || 0
      : analysisInput.afterRepairValue) *
      (assumptionsInput.percentageOfARVFixFlip / 100) -
      analytics.fixFlip.corTotalFixFlip,
    0,
  )

  const effectiveOfferPrice =
    analysis.pepAdjustedPriceFixFlip || pepMaxOfferPrice
  // - analytics.fixFlip.arvTotalFixFlip * 0.1 <-- COMMENTED OUT BASED ON KARL'S NEW CALCULATOR
  // (analytics.fixFlip.corTotalFixFlip + higherPepProfit) <-- JEREMY SAID TO COMMENT OUT RIGHT NOW

  const pepEstProfit =
    analytics.fixFlip.arvTotalFixFlip -
    (analytics.fixFlip.arvTotalFixFlip * 0.15 +
      analytics.fixFlip.corTotalFixFlip +
      effectiveOfferPrice)

  const pepMaxEstProfit = max([
    // pepEstProfit,
    0.1 * analytics.fixFlip.arvTotalFixFlip,
    25000,
  ])

  const extraPepProfit = pepMaxOfferPrice - effectiveOfferPrice
  const dataValues = [analytics.fixFlip.arvTotalFixFlip * 0.1, 25000]

  // Determine the colors dynamically
  // const sortedIndices =
  //   dataValues[0] > dataValues[1] ? [0, 1] : [1, 0]
  // const dynamicColors = sortedIndices.map((index) =>
  //   index === 0 ? '#1BC943' : '#AAEA16',
  // )

  const bigPepChartOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false, // Hides the menu
      },
    },
    plotOptions: {
      bar: {
        // distributed: true, // This ensures each bar gets a different color
      },
    },
    legend: {
      show: true, // Hides the legend
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#1BC943', extraPepProfit > 0 ? '#AAEA16' : '#F83244'],
    // colors: dynamicColors,
    // colors: ['#008FFB', '#00E396', '#FEB019'], // Applies per data point when `distributed: true`
    xaxis: {
      // categories: ['Est Profit', '10% of ARV', '$25,000'],
      categories: ['10% of ARV', '$25,000'],
      labels: {
        show: true, // Ensure it's enabled only once
        // style: { colors: ['#008FFB', '#00E396', '#FEB019'] },
      },
    },
    yaxis: {
      labels: {
        formatter: currencyFormat.format,
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w  }) {
        return (
          '<div class="arrow_box">' +
          '<span>' +
          // ['Est Profit', '10% of ARV', '$25,000'][dataPointIndex] +
          ['10% of ARV', '$25,000'][dataPointIndex] +
          ': ' +
          currencyFormat.format(series[seriesIndex][dataPointIndex]) +
          '</span>' +
          '</div>'
        )
      },
    },
  }

  const bigPepChartSeries = [
    {
      name: 'Mimimum target profit',
      data: dataValues,
    },
    {
      name: 'Profit from adjusted price',
      data: [extraPepProfit, extraPepProfit],
    },
  ]

  const pepBigPictureFields = [
    // {
    //   type: 'slider',
    //   name: 'belowNetProfitPep',
    //   label: 'Net Profit',
    //   value: assumptionsInput['belowNetProfitPep'],
    //   xs: 12,
    //   assumptions: true,
    //   valueLabelFormat: (x) => (x === 25 ? `${x}+` : `${x}%`),
    //   step: 1,
    //   min: 0,
    //   max: 25,
    // },
    // {
    //   type: 'slider',
    //   name: 'belowHoldingClosingCostPep',
    //   label: 'Holding + Closing Cost',
    //   value: assumptionsInput['belowHoldingClosingCostPep'],
    //   xs: 12,
    //   assumptions: true,
    //   valueLabelFormat: (x) => (x === 25 ? `${x}+` : `${x}%`),
    //   step: 1,
    //   min: 0,
    //   max: 25,
    // },
    // {
    //   type: 'slider',
    //   name: 'belowTotalCostFinancingPep',
    //   label: 'Total Cost Financing',
    //   value: assumptionsInput['belowTotalCostFinancingPep'],
    //   xs: 12,
    //   assumptions: true,
    //   valueLabelFormat: (x) => (x === 25 ? `${x}+` : `${x}%`),
    //   step: 1,
    //   min: 0,
    //   max: 25,
    // },
    {
      type: 'dollar',
      name: 'listPrice',
      label: 'Asking Price',
      value:
        analysisInput.listPrice === null
          ? ''
          : analysisInput.listPrice.toString(),
      xs: 12,
      lg: 6,
      definition: 'listPrice',
      // tooltipField: 'The price that the seller is asking for this home. *Not necessarily the price that the investor will purchase the home for.',
      // tooltipButtonText: 'Asking Price Options',
      adornmentNumber: 1,
    },
    {
      type: 'dollar',
      name: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueFixFlip'
        : 'afterRepairValue',
      label: 'After Repair Value',
      // tooltipButtonText: 'Show ARV data',
      value: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? analysisInput.afterRepairValueFixFlip === null
          ? ''
          : analysisInput.afterRepairValueFixFlip.toString()
        : analysisInput.afterRepairValue === null
          ? ''
          : analysisInput.afterRepairValue.toString(),
      //helper: currencyFormat.format(analytics.fixFlip.equity) + ' in equity',
      xs: 12,
      lg: 6,
      definition: 'afterRepairValue',
      definitionTarget: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueFixFlip'
        : 'afterRepairValue',
      // tooltipField: 'The ARV is the value of a property after you have conducted repairs and are ready to sell',
      dataTour: 'acquisitionExpenses-step-6',
      dataTourDatabase: 'acquisitionExpenses-step-7',
      adornmentNumber: 2,
    },
    ...map(rehabFields, (field, index) => ({
      ...field,
      adornmentNumber: index + 3,
    })),
    {
      type: 'percentage',
      name: 'percentageOfARVFixFlip',
      label: 'Percent of ARV',
      // tooltipButtonText: 'Show Purchase Price data',
      helper: currencyFormat.format(
        (includes(
          assumptionsInput.strategySpecificFields,
          'afterRepairValue',
        )
          ? analysisInput.afterRepairValueFixFlip === null
            ? 0
            : Number(analysisInput.afterRepairValueFixFlip)
          : analysisInput.afterRepairValue === null
            ? 0
            : Number(analysisInput.afterRepairValue)) *
          (assumptionsInput.percentageOfARVFixFlip / 100),
      ),
      value: assumptionsInput.percentageOfARVFixFlip,
      xs: 12,
      lg: 6,
      assumptions: true,
      // tooltipField: 'Percentage of ARV used to calculate Offer Price',
      adornmentNumber: 6,
    },

    {
      type: 'dollar',
      name: 'pepAdjustedPriceFixFlip',
      label: 'Adjusted Purchase Price',
      // tooltipButtonText: 'Show Purchase Price data',
      value:
        analysis.pepAdjustedPriceFixFlip === null
          ? //? analysisInput.listPrice.toString()
            ''
          : analysis.pepAdjustedPriceFixFlip.toString(),
      xs: 12,
      lg: 6,
      // tooltipField: 'The price that the seller is asking for this home. *Not necessarily the price that the investor will purchase the home for.',
      dataTour: 'acquisitionExpenses-step-4',
      dataTourDatabase: 'acquisitionExpenses-step-5',
      adornmentNumber: 7,
    },
  ]

  const pitiFields = [
    {
      type: 'dollar',
      label: 'Principal',
      name: 'pitiData.principal',
      value: propertyInput?.pitiData.principal,
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      type: 'dollar',
      label: 'Interest',
      name: 'pitiData.interest',
      value: propertyInput?.pitiData.interest,
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      type: 'dollar',
      label: 'Taxes',
      name: 'pitiData.taxes',
      value: propertyInput?.pitiData.taxes,
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      type: 'dollar',
      label: 'Insurance',
      name: 'pitiData.insurance',
      value: propertyInput?.pitiData.insurance,
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      type: 'text',
      label: 'Loan type',
      name: 'pitiData.loanType',
      value: propertyInput?.pitiData.loanType,
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      type: 'datePicker',
      label: 'Origination Date',
      name: 'pitiData.originDate',
      value: new Date(propertyInput?.pitiData.originDate),
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      name: 'pitiData.mortgageStatement',
      label: 'Mortgage statement',
      type: 'file',
      value: propertyInput?.pitiData.mortgageStatement,
      uploadFile: props.uploadFileProperty(
        'pitiData.mortgageStatement',
      ),
      // deleteFile: props.deleteFileProperty(),
      buttonText: 'Upload Mortgage statement',
      xs: 12,
      lg: 6,
      details: true,
    },
    {
      name: 'pitiData.insuranceStatement',
      label: 'Insurance statement',
      type: 'file',
      value: propertyInput?.pitiData.insuranceStatement,
      uploadFile: props.uploadFileProperty(
        'pitiData.insuranceStatement',
      ),
      // deleteFile: props.deleteFileProperty(),
      buttonText: 'Upload Insurance statement',
      xs: 12,
      lg: 6,
      details: true,
    },
  ]

  const strategySummary = activeOrg.isRealeflow
    ? createStrategySummary(
        analytics,
        'fixFlip',
        'Fix & Flip',
        [
          {
            value: analytics.fixFlip.netProfitPep || '-',
            arrow: analytics.fixFlip.netProfitPepArrow || 0,
            label: 'Net Profit',
            target: assumptions.belowNetProfitPep,
            targetLabel: 'Min Net Profit Target',
            targetName: 'belowNetProfitPep',
            // tourStep: 'targets-step-2',
            min: 0,
            max: 25,
            minLabel: '0%',
            maxLabel: '25%',
            description: 'Profit as a percentage of ARV',
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {analysis.resellPriceFixFlip
                        ? 'Resale Price'
                        : 'After Repair Value'}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {currencyFormat.format(
                        round(
                          analysis.resellPriceFixFlip ||
                            analytics.fixFlip.arvTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-Holding Expenses</Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-{currencyFormat.format(round(sum(holdingExpensesChartSeries), 0))}</Typography>
              </Grid>
            </Grid> */}
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Sales Commission
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .salesCommissionTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Disposititon Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .dispositionFeeDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Total Out-of-Pocket
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.totalOutOfPocketFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Remaining Loan Balance
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .loanBalanceAtHoldingPeriod,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Net Profit
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(analytics.fixFlip.saleProceeds, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      After Repair Value
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      {currencyFormat.format(
                        round(analytics.fixFlip.arvTotalFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Net Profit to ARV
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {analytics.fixFlip.netProfitPep > 1000
                        ? '+1000%'
                        : percentageFormat.format(
                            analytics.fixFlip.netProfitPep,
                          )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
          {
            value: analytics.fixFlip.holdingClosingCostPep || '-',
            arrow: analytics.fixFlip.holdingClosingCostPepArrow || 0,
            label: 'Holding + Closing Cost',
            target: assumptions.belowHoldingClosingCostPep,
            targetLabel: 'Min Holding + Closing Cost Target',
            targetName: 'belowHoldingClosingCostPep',
            // tourStep: 'targets-step-3',
            min: 0,
            max: 25,
            minLabel: '0%',
            maxLabel: '25%',
            description:
              'Holding + Closing Cost as a percentage of ARV.',
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      Closing Costs
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.closeCostDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Holding Expenses
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(sum(holdingExpensesChartSeries), 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Holding + Closing Cost
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.closeCostDollarFixFlip +
                            sum(holdingExpensesChartSeries),
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      After Repair Value
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      {currencyFormat.format(
                        round(analytics.fixFlip.arvTotalFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Holding + Closing Cost to ARV
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {analytics.fixFlip.holdingClosingCostPep > 1000
                        ? '+1000%'
                        : percentageFormat.format(
                            analytics.fixFlip.holdingClosingCostPep,
                          )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
          {
            value: analytics.fixFlip.totalCostFinancingPep || '-',
            arrow: analytics.fixFlip.totalCostFinancingPepArrow || 0,
            label: 'Total Cost Financing',
            target: assumptions.belowTotalCostFinancingPep,
            targetLabel: 'Min Total Cost Financing Target',
            targetName: 'belowTotalCostFinancingPep',
            // tourStep: 'targets-step-4',
            min: 0,
            max: 25,
            minLabel: '0%',
            maxLabel: '25%',
            description: `Total Cost Financing as a percentage of ARV`,
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      Loan Points
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.pointsAmountFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Financing Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.financingFeeTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Loan Balance Interest
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .mpInterestOnlyLoanFixFlip *
                            assumptions.holdingPeriod,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Total Cost Financing
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.pointsAmountFixFlip +
                            analytics.fixFlip
                              .financingFeeTotalFixFlip +
                            analytics.fixFlip
                              .mpInterestOnlyLoanFixFlip *
                              assumptions.holdingPeriod,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      After Repair Value
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      {currencyFormat.format(
                        round(analytics.fixFlip.arvTotalFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Total Cost Financing to ARV
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {analytics.fixFlip.totalCostFinancingPep > 1000
                        ? '+1000%'
                        : percentageFormat.format(
                            analytics.fixFlip.totalCostFinancingPep,
                          )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
        ],
        {
          belowKey: 'belowTargetFlipPep',
          onKey: 'onTargetFlipPep',
          aboveKey: 'aboveTargetFlipPep',
        },
      )
    : createStrategySummary(
        analytics,
        'fixFlip',
        'Fix & Flip',
        [
          {
            value: analytics.fixFlip.saleProceeds || '-',
            arrow: analytics.fixFlip.saleProceedsArrow || 0,
            label: 'Net Profit',
            type: 'currency',
            target: assumptions.belowSaleProceeds,
            targetLabel: 'Min Net Profit Target',
            targetName: 'belowSaleProceeds',
            tourStep: 'targets-step-2',
            min: 0,
            max: 35000,
            minLabel: '$ 0',
            maxLabel: '$ 35k',
            step: 1000,
            valueLabelFormat: (x) =>
              x >= 1000 ? `${x / 1000}k` : `${x}`,
            description:
              'The amount of money left over from selling your home after accounting for the remaining mortgage balance, closing costs, and realtor fees.',
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {analysis.resellPriceFixFlip
                        ? 'Resale Price'
                        : 'After Repair Value'}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {currencyFormat.format(
                        round(
                          analysis.resellPriceFixFlip ||
                            analytics.fixFlip.arvTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-Holding Expenses</Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-{currencyFormat.format(round(sum(holdingExpensesChartSeries), 0))}</Typography>
              </Grid>
            </Grid> */}
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Sales Commission
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .salesCommissionTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Disposititon Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .dispositionFeeDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Total Out-of-Pocket
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.totalOutOfPocketFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Remaining Loan Balance
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .loanBalanceAtHoldingPeriod,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Net Profit
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(analytics.fixFlip.saleProceeds, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
          {
            value: analytics.fixFlip.netROIFixFlip || '-',
            arrow: analytics.fixFlip.netROIArrow || 0,
            label: 'Net ROI',
            target: assumptions.belowNetROI,
            targetLabel: 'Min Net ROI Target',
            targetName: 'belowNetROI',
            tourStep: 'targets-step-3',
            min: 0,
            max: 25,
            minLabel: '0%',
            maxLabel: '25%',
            description:
              'Return on investment (ROI) indicates the percentage of investment money that is recouped after the deduction of associated costs.',
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {analysis.resellPriceFixFlip
                        ? 'Resale Price'
                        : 'After Repair Value'}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {currencyFormat.format(
                        round(
                          analysis.resellPriceFixFlip ||
                            analytics.fixFlip.arvTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Holding Expenses
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(sum(holdingExpensesChartSeries), 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Sales Commission
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .salesCommissionTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Disposititon Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .dispositionFeeDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Total Out-of-Pocket
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.totalOutOfPocketFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -Remaininig Loan Balance
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      -
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .loanBalanceAtHoldingPeriod,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Net Profit
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(analytics.fixFlip.saleProceeds, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      All-in-cost
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      {currencyFormat.format(
                        round(analytics.fixFlip.allInCostFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      Net ROI
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {analytics.fixFlip.netROIFixFlip > 1000
                        ? '+1000%'
                        : percentageFormat.format(
                            analytics.fixFlip.netROIFixFlip,
                          )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
          {
            value: analytics.fixFlip.percentageOfARV,
            arrow: analytics.fixFlip.percentageOfARVArrow || 0,
            label: 'All-In Cost to ARV',
            target: assumptions.belowARV,
            targetLabel: 'Min All-In Cost to ARV Target',
            targetName: 'belowARV',
            tourStep: 'targets-step-4',
            min: 50,
            max: 90,
            minLabel: '50%',
            maxLabel: '90%',
            description: `The All-In Cost to ARV (After Repair Value) that you purchase the property for. There is a popular term referred to as the "70% rule" when applied to fix and flipping houses.  The 70% rule states that an investor should pay 70 percent of the ARV of a property, minus the repairs needed.  The ARV is the after repaired value and is what a home is worth after it is fully repaired.  This "rule" says 70% but we have still found success at 80% of the ARV.`,
            calculation: (
              <>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      Purchase Price
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      {currencyFormat.format(
                        round(
                          analysis.offerPrice || analysis.listPrice,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Acquisition Commission
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.acquisitionCommissionDollar,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Acquisition Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(assumptions.acquisitionFee, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Closing Costs
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.closeCostDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Seller Closing Costs
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip
                            .sellingClosingCostDollarFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Loan Points
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.pointsAmountFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Custom Acquisition Expenses
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.customAcquisitionExpenseTotal,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Rehab Amount
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(analytics.fixFlip.corTotalFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Financing Fee
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(
                          analytics.fixFlip.financingFeeTotalFixFlip,
                          0,
                        ),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +Holding Expenses
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      +
                      {currencyFormat.format(
                        round(sum(holdingExpensesChartSeries), 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      All-in Cost
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {currencyFormat.format(
                        round(analytics.fixFlip.allInCostFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      After Repair Value
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyMutedTextSx}>
                      <FontAwesomeIcon
                        icon={['fal', 'divide']}
                        style={strategyIconGapStyle}
                      />
                      {currencyFormat.format(
                        round(analytics.fixFlip.arvTotalFixFlip, 0),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={strategyMutedDividerSx} />
                <Grid
                  container
                  sx={[strategyMetricRowSx, {
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }]}
                >
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      All-in Cost to ARV
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={strategyWhiteTextSx}>
                      {analytics.fixFlip.percentageOfARV > 1000
                        ? '+1000%'
                        : percentageFormat.format(
                            analytics.fixFlip.percentageOfARV,
                          )}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ),
          },
        ],
        {
          belowKey: 'belowTargetFlip',
          onKey: 'onTargetFlip',
          aboveKey: 'aboveTargetFlip',
        },
      )

  const financials = [
    {
      value: analytics.fixFlip.allInCostFixFlip,
      label: 'All-in Cost',
      description:
        'Total amount of initial investment into a property, including renovation and points paid for financing.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Purchase Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analysis.offerPrice || analysis.listPrice, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.acquisitionCommissionDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.fixFlip.closeCostDollarFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Seller Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.fixFlip.sellingClosingCostDollarFixFlip,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.fixFlip.pointsAmountFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.fixFlip.corTotalFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.fixFlip.financingFeeTotalFixFlip,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Owner Reserves
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.ownerReservesFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Holding Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(sum(holdingExpensesChartSeries), 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                All-in Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.fixFlip.allInCostFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      ),
    },
    {
      value: analytics.fixFlip.totalOutOfPocketFixFlip,
      label: 'Total Out-of-Pocket',
      description:
        'Total amount of cash that a buyer has put into a property of his/her own capital.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Down Payment
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analytics.fixFlip.downPaymentTotalFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.acquisitionCommissionDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.fixFlip.closeCostDollarFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Seller Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.fixFlip.sellingClosingCostDollarFixFlip,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.fixFlip.financingFeeTotalFixFlip,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.fixFlip.pointsAmountFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Credit From Seller
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(assumptions.creditFromSeller, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.fixFlip.repairsOutOfPocketFixFlip,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Holding Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(sum(holdingExpensesChartSeries), 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Out-of-Pocket
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.fixFlip.totalOutOfPocketFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      ),
    },
    {
      value: pepMaxOfferPrice,
      label: 'Property Edge Pro - Max Offer Price',
      description: 'Highest Recommended Offer Price',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                After Repair Value
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  analytics.fixFlip.arvTotalFixFlip,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                *Percentage of ARV
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                *
                {percentageFormat.format(
                  assumptions.percentageOfARVFixFlip / 100,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Sugested Offer Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  (analytics.fixFlip.arvTotalFixFlip *
                    assumptions.percentageOfARVFixFlip) /
                    100,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Rehab Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.fixFlip.corTotalFixFlip, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          {/* <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={strategyMetricRowSx}
          >
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -10% of ARV
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  analytics.fixFlip.arvTotalFixFlip * 0.1,
                )}
              </Typography>
            </Grid>
          </Grid> */}
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: 'center',
              justifyContent: 'space-between',
            }]}
          >
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Offer Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(pepMaxOfferPrice)}
              </Typography>
            </Grid>
          </Grid>
        </>
      ),
    },
  ]

  const compData = calculateCompData({
    compValues: props.compValues,
    lowestAverage: props.lowestAverage,
  })

  const fixAndFlipCards = [
    {
      name: 'bigPicture',
      hide: !activeOrg.isRealeflow,
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Big Picture</b>
            </Box>
            {/* <div>
              <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
                <Button onClick={() => setOpenFixFlipFinancingTour(true)}>
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div> */}
          </Box>
          <Divider />
          <CardContent>
            {/* <p data-tour="financing-step-3">
              Based on your <b>{currencyFormat.format(analytics.fixFlip.allInCostFixFlip)}</b> <Tooltip title='The total amount of money this deal costs, including rehab, closing costs, points, etc.'><span onClick={() => toggle1('All-in Cost')} style={{ textDecoration: 'underline' }}>all-in cost</span></Tooltip>, you'll need to pay <b>{currencyFormat.format(analytics.fixFlip.totalOutOfPocketFixFlip)}</b> <Tooltip title='Total amount that the buyer has to cover with their own money.'><span onClick={() => toggle1('Total Out-of-Pocket')} style={{ textDecoration: 'underline' }}>out-of-pocket</span></Tooltip> to cover the downpayment, closing costs, and rehab for this property.
            </p> */}
            {/* <Divider sx={strategyBlockSpacerSx} /> */}
            <Grid container>
              <Grid>
                <Grid
                  container
                  direction="row"
                  // alignItems="center"
                  spacing={1}
                >
                  {map(pepBigPictureFields, (section) =>
                    renderInputFields(section),
                  )}
                </Grid>
                <Box sx={[{ borderRadius: '0.65rem', p: '0.5rem', mb: '0.5rem', backgroundColor: '#f8f9ff', textAlign: 'center', }, { borderWidth: "1px !important", borderStyle: "solid !important" }]} sx={strategyBorderMutedSx}>
                  <Grid
                    container

                    sx={{
                      display: 'flex',
                      backgroundColor: '#fff',
                      justifyContent: 'space-between',
                      py: '1rem',
                    }}
                  >
                    <Grid
                      container
                      direction="column"

                      onClick={() =>
                        toggle1('Property Edge Pro - Max Offer Price')
                      }
                      sx={{
                        display: 'flex',
                        backgroundColor: '#fff',
                        py: '1rem',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                      }}
                    >
                      <Grid data-hf-grid="keep">
                        <Typography variant="h3">
                          {pepMaxOfferPrice > 0
                            ? currencyFormat.format(pepMaxOfferPrice)
                            : '-'}
                        </Typography>
                      </Grid>
                      <Grid
                        data-hf-grid="keep"
                        sx={strategyCenterTextSx}
                      >
                        <Typography sx={{ color: 'black' }}>
                          Suggested Offer Price
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div data-tour="financing-step-1">
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Estimated Profit
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            {/* <div>
                        fast
                      </div> */}
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={pepMaxEstProfit + extraPepProfit}
                                duration={1}
                                separator=","
                                decimals={0}
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div data-tour="financing-step-2">
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Strength of Offer
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            {/* <div>
                        normal
                      </div> */}
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={round(
                                  (effectiveOfferPrice /
                                    analysis.listPrice || 0) * 100,
                                  0,
                                )}
                                duration={1}
                                delay={2}
                                separator=","
                                decimals={0}
                                suffix="%"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                {/* {!props.shared && (
                  <div>
                    <ContactAgent
                      property={property}
                      propertyPage={true}
                      canDrag={props.canDrag}
                      defaultOffer={effectiveOfferPrice}
                    />
                  </div>
                )} */}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'bigPictureSummary',
      hide: !activeOrg.isRealeflow,
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyTableRowSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Big Picture Summary</b>
            </Box>
            {/* <div>
              <Tooltip title="Quick glance determination seen on the main page">
                <Button onClick={() => toggleStrategyTour()}>
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div> */}
          </Box>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', px: '1.5rem', pt: '1.5rem', pb: '1rem', }} />
            <Box
              component="span"
              data-tour-fixFlip="gauge-step-1"

              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                justifyContent: 'center',
                px: '1.5rem',
                pt: '1.5rem',
                pb: '1rem',
              }}
            >
              <Box sx={[strategyPadBottom20Sx, { mx: 'auto', overflow: 'hidden' }]}>
                <GaugeChart
                  id="chartsGauges3B"
                  nrOfLevels={6}
                  colors={['#f83245', '#f4772e', '#1bc943']}
                  arcWidth={0.4}
                  hideText
                  percent={
                    effectiveOfferPrice / analysis.listPrice > 0.9
                      ? 1
                      : effectiveOfferPrice / analysis.listPrice < 0.7
                        ? 0
                        : (effectiveOfferPrice / analysis.listPrice -
                            0.7) *
                            ((5 * 2) / 3) +
                          1 / 6
                  }
                />
              </Box>
              <Box
                component="p" sx={[strategyMutedPadXSx, { mb: '1rem', textAlign: 'center' }]}>
                Your current Strength of Offer is{' '}
                {analysis.listPrice
                  ? `${round(
                      (effectiveOfferPrice / analysis.listPrice ||
                        0) * 100,
                      0,
                    )}
                  %${' '}`
                  : '-'}
              </Box>
            </Box>
            <Box
              component="span"
              data-tour-fixFlip="gauge-step-2"

              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                justifyContent: 'center',
                px: '1.5rem',
                pt: '1.5rem',
                pb: '1rem',
              }}
            >
              <Box sx={[strategyPadBottom20FullSx, { mx: 'auto', overflow: 'hidden' }]}>
                <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                  <Chart
                    options={bigPepChartOptions}
                    series={bigPepChartSeries}
                    type="bar"
                  />
                </Suspense>
              </Box>
              <Box
                component="p" sx={[strategyMutedPadXSx, { mb: '1rem', textAlign: 'center' }]}>
                {/* Between your Net Profit and 10% of the ARV,{' '}
                {(pepEstProfit || 25000) >
                0.1 * analytics.fixFlip.arvTotalFixFlip
                  ? 'Net Profit'
                  : '10% of ARV'}{' '}
                is higher with a total of{' '}
                {currencyFormat.format(pepMaxEstProfit)}{' '} */}
                Check to see that the total profit is at least $25,000
                or 10% of ARV, whichever is higher.
              </Box>
            </Box>
            {!props.shared && (
              <Box sx={{ px: '1.5rem', pb: '1.5rem', pt: '0.5rem' }}>
                <ContactAgent
                  property={property}
                  propertyPage={true}
                  canDrag={props.canDrag}
                  defaultOffer={effectiveOfferPrice}
                />
              </Box>
            )}
          </Box>
        </Card>
      ),
    },
    {
      name: 'strategy',
      card: (
        <StrategyCard
          strategyName="Fix & Flip"
          activeOrg={activeOrg}
          percentage={strategySummary.percentage}
          onStrategyTourClick={toggleStrategyTour}
          shared={props.shared}
          property={property}
          canDrag={props.canDrag}
          contactAgent={
            !props.shared && activeOrg.member !== 'gorillacapital' ? (
              <Box sx={{ px: '1.5rem', pb: '1.5rem', pt: '0.5rem' }}>
                <ContactAgent
                  property={property}
                  propertyPage={true}
                  canDrag={props.canDrag}
                />
              </Box>
            ) : null
          }
        >
          {activeOrg.member === 'gorillacapital' && (
            <Box sx={{ px: '1.5rem', pb: '1.5rem', pt: '0.5rem' }}>
              {property.lender ? (
                <Card variant="outlined">
                  <CardContent sx={{ px: '1.5rem', py: '1rem' }}>
                    <Box
                      sx={{
                        pb: '1rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      Property Submission Status
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Box component="span" sx={strategyWhiteBlueChipSx}>
                        {property.lenderStatus}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              ) : (
                <Button
                  fullWidth
                 
                  onClick={
                    props.fixFlipPercentage < 100
                      ? () => props.setOpenMemberDisclaimer(true)
                      : () => props.setOpenMember(true)
                  }
                >
                  <Box component="span" sx={strategyInlineFlexSx}>
                    <img
                      src="/images/white-gorilla-only.png"
                      alt="gorilla"
                      height={50}
                    />
                  </Box>
                  <Box component="span" sx={[strategyFont16Sx, {
                    display: "inline-block",
                    "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                    "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                  }]}>
                    Submit to Gorilla
                  </Box>
                </Button>
              )}
            </Box>
          )}
        </StrategyCard>
      ),
    },
    {
      name: 'targets',
      card: (
        <TargetsCard
          strategySummary={strategySummary}
          currencyFormat={currencyFormat}
          percentageFormat={percentageFormat}
          modal1={modal1}
          toggle1={toggle1}
          toggle1Close={toggle1Close}
          renderInputFields={renderInputFields}
          assumptionsInput={assumptionsInput}
          maxOfferPrice={
            !activeOrg.isRealeflow
              ? analytics.fixFlip.maxFixAndFlipPricePep
              : analytics.fixFlip.maxFixAndFlipPrice
          }
          toggleMaxOffer={toggleMaxOffer}
          maxOfferDescription={maxOfferDescription}
          onTargetsTourClick={toggleTargetsTour}
          maxOfferCalculation={
            <>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    Purchase Price:
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {currencyFormat.format(
                      analysisInput.offerPrice
                        ? analysisInput.offerPrice
                        : analysisInput.listPrice,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    Resale Price:
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {currencyFormat.format(
                      analysisInput.resellPriceFixFlip,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    All In Cost:
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {currencyFormat.format(
                      analytics.fixFlip.allInCostFixFlip,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    Total Out Of Pocket:
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {currencyFormat.format(
                      analytics.fixFlip.totalOutOfPocketFixFlip,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    Net Profit:
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {currencyFormat.format(
                      analytics.fixFlip.saleProceeds,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={[strategyMetricRowSx, {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }]}
              >
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    Holding Period (months):
                  </Typography>
                </Grid>
                <Grid>
                  <Typography sx={strategyMutedTextSx}>
                    {assumptionsInput.holdingPeriod}
                  </Typography>
                </Grid>
              </Grid>
            </>
          }
        />
      ),
    },
    {
      name: 'netProfit',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyTableRowSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <small
                sx={{
                  display: 'block',
                  textTransform: 'uppercase',
                  mt: '0.25rem',
                }}
              >
                Summary
              </small>
              <b>Net Profit from Sale</b>
            </Box>
            <div>
              <Tooltip title="Breakdown of the resale price minus expenses to show net profit">
                <Button
                  onClick={() => toggleNetProfitTour()}
                 
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Box sx={[{ borderRadius: '0.65rem', p: '0.5rem', mb: '0.5rem', backgroundColor: '#f8f9ff', textAlign: 'left', }, { borderWidth: "1px !important", borderStyle: "solid !important" }]} sx={strategyBorderMutedSx}>
                <Grid container sx={[strategyTextMuted802Sx, { fontSize: "0.875rem !important" }]}>
                  <Grid
                    size={{ md: 4 }}
                    data-tour="netProfitFromSale-step-1"

                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  >
                    <div>
                      <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                        Resale Price
                      </Box>
                      <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                        <Box
                          sx={{
                            display: 'flex',
                            p: '0.25rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                           
                            sx={{
                              display: "inline-block",
                              py: 0,
                              px: "0.7em",
                              fontSize: "70%",
                              fontWeight: 700,
                              lineHeight: "21px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              verticalAlign: "baseline",
                              borderRadius: "100%",
                              textTransform: "uppercase",
                              height: 10,
                              color: "#fff",
                              backgroundColor: "#1bc943",
                              textIndent: "-999rem",
                              width: 10,
                              p: 0,
                              boxShadow: "0 0 0 2px #fff",
                              mr: "0.5rem",
                            }}
                          >
                            fast
                          </Box>
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              whiteSpace: 'nowrap',
                              lineHeight: 1.3,
                            }}
                          >
                            <CountUp
                              start={0}
                              end={analysis.resellPriceFixFlip / 1000}
                              duration={1}
                              delay={2}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ md: 4 }}
                    data-tour="netProfitFromSale-step-2"

                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  >
                    <div>
                      <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                        Expenses
                      </Box>
                      <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                        <Box
                          sx={{
                            display: 'flex',
                            p: '0.25rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                           
                            sx={{
                              display: "inline-block",
                              py: 0,
                              px: "0.7em",
                              fontSize: "70%",
                              fontWeight: 700,
                              lineHeight: "21px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              verticalAlign: "baseline",
                              borderRadius: "100%",
                              textTransform: "uppercase",
                              height: 10,
                              color: "#fff",
                              backgroundColor: "#f83245",
                              textIndent: "-999rem",
                              width: 10,
                              p: 0,
                              boxShadow: "0 0 0 2px #fff",
                              mr: "0.5rem",
                            }}
                          >
                            normal
                          </Box>
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              whiteSpace: 'nowrap',
                              lineHeight: 1.3,
                            }}
                          >
                            <CountUp
                              start={0}
                              end={
                                (analytics.fixFlip
                                  .totalOutOfPocketFixFlip +
                                  //+ sum(holdingExpensesChartSeries)  ##SPECIFIC COMMENT: holding expenses are part of the sellingTotalOutOfPocket
                                  //+ analytics.fixFlip.closeCostDollarFixFlip
                                  analytics.fixFlip
                                    .salesCommissionTotalFixFlip +
                                  analytics.fixFlip
                                    .dispositionFeeDollarFixFlip +
                                  analytics.fixFlip
                                    .loanBalanceAtHoldingPeriod) /
                                1000
                              }
                              duration={1}
                              delay={2}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ md: 4 }}
                    data-tour="netProfitFromSale-step-3"

                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  >
                    <div>
                      <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                        Net Profit
                      </Box>
                      <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                        <Box
                          sx={{
                            display: 'flex',
                            p: '0.25rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                           
                            sx={{
                              display: "inline-block",
                              py: 0,
                              px: "0.7em",
                              fontSize: "70%",
                              fontWeight: 700,
                              lineHeight: "21px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              verticalAlign: "baseline",
                              borderRadius: "100%",
                              textTransform: "uppercase",
                              height: 10,
                              color: "#fff",
                              backgroundColor: "#368cff",
                              textIndent: "-999rem",
                              width: 10,
                              p: 0,
                              boxShadow: "0 0 0 2px #fff",
                              mr: "0.5rem",
                            }}
                          >
                            slow
                          </Box>
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              whiteSpace: 'nowrap',
                              lineHeight: 1.3,
                            }}
                          >
                            <CountUp
                              start={0}
                              end={
                                analytics.fixFlip.saleProceeds / 1000
                              }
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={0}
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                </Grid>
              </Box>
              <>
                <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                  <Chart
                    options={chartOptions}
                    series={chartSeries}
                    type="bar"
                    height={280}
                  />
                </Suspense>
              </>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'acquisition',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Acquisition Expenses</b>
            </Box>
            <div>
              <Tooltip title="The total projected expenses required to purchase the property">
                <Button
                  onClick={() =>
                    setOpenFixFlipAcquisitionExpensesTour(true)
                  }
                 
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      data-tour="acquisitionExpenses-step-1"
                      options={acquisitionChartOptions}
                      series={acquisitionChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  // alignItems="center"
                  spacing={1}
                >
                  <Grid
                    size={12}
                    container
                    wrap="nowrap"
                    sx={{
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <Grid data-tour="acquisitionExpenses-step-2">
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="Advanced Fields"
                              checked={state.checkedA}
                              onChange={handleChange}
                              name="checkedA"
                            />
                          }
                          label="Advanced Fields"
                        />
                      </FormGroup>
                    </Grid>
                    {(!props.publicDashboard ||
                      !property.hideDaysOnMarketplace) && (
                      <Grid data-tour="acquisitionExpenses-step-3">
                        <Tooltip title="Refers to the number of days a house is listed on the market and the day it is sold.">
                          <Typography sx={strategyTableCellRightSx}>
                            <FontAwesomeIcon
                              icon={['far', 'clock']}
                              style={strategyIconGap5Style}
                            />
                            {analysisInput.daysOnMarket} days on
                            market
                          </Typography>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                  {map(
                    state.checkedA
                      ? concat(
                          basicAcquisitionFields,
                          advancedAcquisitionFields,
                          customAcquisitonField,
                        )
                      : concat(
                          basicAcquisitionFields,
                          customAcquisitonField,
                        ),
                    (field) => renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'income',
      card: (
        <Card variant="outlined"
         
          sx={strategyFullWidthSx}
          sx={{ width: '100%' }}
        >
          <Grid
            container
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              py: "0.75rem",
              px: "1.25rem",
              mb: 0,
              backgroundColor: "#fff",
              "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
            }}
          >
            <Grid size={8} sx={{ minWidth: 0 }}>
              <List sx={{
                display: "flex",
                alignItems: "stretch",
                gap: 0.5,
                p: 0,
                m: 0,
                minHeight: 40,
              }}>
                {analysisInput.rent.length > 1 ? (
                  map(analysisInput.rent, (value, index) => (
                    <ListItemButton
                      key={`unit-${index}`}
                      selected={props.activeUnit === index}
                      onClick={() => props.setActiveUnit(index)}
                      sx={{
                        width: "auto",
                        minWidth: "auto",
                        px: 1.5,
                        py: 1,
                        minHeight: 40,
                        borderRadius: 0,
                        color: "#4f5062",
                        fontWeight: 500,
                        "&.Mui-selected": {
                          color: "#368cff",
                          fontWeight: 700,
                          bgcolor: "transparent",
                          borderBottom: "3px solid #368cff",
                        },
                        "&.Mui-selected:hover": { bgcolor: "transparent", color: "#368cff" },
                      }}
                    >
                      Unit {index + 1}
                    </ListItemButton>
                  ))
                ) : (
                  <ListItem sx={{ my: '0.25rem' }}>
                    <Box sx={{
                      flexGrow: 1,
                      minWidth: 0,
                      "& > b": { display: "block" },
                      "& > small": {
                        textTransform: "uppercase",
                        display: "block",
                        opacity: 0.3,
                        fontWeight: "bold",
                      },
                    }}>
                      <b>Gross Monthly Income</b>
                    </Box>
                  </ListItem>
                )}
              </List>
            </Grid>
            <Grid style={strategyIconGap20Style}>
              <Tooltip title="Total income generated from the property on a monthly basis">
                {assumptionsInput.rentType === 'singleRent' ? (
                  <Button
                    onClick={() =>
                      setOpenFixFlipGrossMonthlyIncomeSingleRentTour(
                        true,
                      )
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                ) : (
                  <Button
                    onClick={() =>
                      setOpenFixFlipGrossMonthlyIncomeRentRangeTour(
                        true,
                      )
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                )}
              </Tooltip>
            </Grid>
          </Grid>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      data-tour="grossMonthlyIncomeSingleRent-step-1-grossMonthlyIncomeRentRange-step-1"
                      options={grossMonthlyIncomeChartOptions}
                      series={grossMonthlyIncomeChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: 'flex-start',
                  }}
                >
                  {assumptionsInput.rentType === 'singleRent'
                    ? map(
                        grossMonthlyIncomeSingleRentFields,
                        (field) => renderInputFields(field),
                      )
                    : map(
                        grossMonthlyIncomeRentRangeFields,
                        (field) => renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'rehab',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Rehab Expenses</b>
            </Box>
            <div>
              {/* <Tooltip title="Estimated expenses allocated to the renovations of a property">
                <Button onClick={() => setOpenFixFlipRehabExpensesTour(true)}>
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip> */}
              <Tooltip title="Estimated expenses allocated to the renovations of a property">
                {assumptionsInput.rehabType === 'detailedRehab' ? (
                  <Button
                    onClick={() =>
                      setOpenFixFlipRehabExpensesDetailedRehabTour(
                        true,
                      )
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                ) : assumptionsInput.rehabType === 'rehabTier' ? (
                  <Button
                    onClick={() =>
                      setOpenFixFlipRehabExpensesRehabTierTour(true)
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                ) : assumptionsInput.rehabType ===
                  'flippingAmericaRehab' ? (
                  <Button
                    onClick={() =>
                      setOpenFixFlipRehabExpensesFlippingAmericaRehabTour(
                        true,
                      )
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                ) : (
                  <Button
                    onClick={() =>
                      setOpenFixFlipRehabExpensesSingleRehabValueTour(
                        true,
                      )
                    }
                   
                    sx={{
                      backgroundColor: "rgba(54, 140, 255, 0.15)",
                      color: "#368cff",
                      borderColor: "transparent",
                      "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                      "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                      height: "30px !important",
                      width: "30px !important",
                      lineHeight: "30px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      border: 0,
                      textAlign: "left",
                    }}
                  >
                    <FontAwesomeIcon icon={['fal', 'info-circle']} />
                  </Button>
                )}
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      data-tour="rehabExpenses-step-1"
                      options={rehabChartOptions}
                      series={rehabChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  {map(rehabFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'holding',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Holding Expenses</b>
            </Box>
            <div>
              <Tooltip title="Projected breakdown of a property's expenses during a determined holding period">
                <Button
                  onClick={() =>
                    setOpenFixFlipHoldingExpensesTour(true)
                  }
                 
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      data-tour="holdingExpenses-step-1"
                      options={holdingExpensesChartOptions}
                      series={holdingExpensesChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: 'flex-start',
                  }}
                >
                  {map(holdingExpensesFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'financing',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Financing</b>
            </Box>
            <div>
              <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
                <Button
                  onClick={() => setOpenFixFlipFinancingTour(true)}
                 
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Box sx={[{ borderRadius: '0.65rem', p: '0.5rem', mb: '0.5rem', backgroundColor: '#f8f9ff', textAlign: 'center', }, { borderWidth: "1px !important", borderStyle: "solid !important" }]} sx={strategyBorderMutedSx}>
              <Grid container sx={[strategyTextMuted802Sx, { fontSize: "0.875rem !important" }]}>
                <Grid
                  size={{
                    md:
                      !activeOrg.isRealeflow &&
                      (!activeOrg.isAffiliate ||
                        !activeOrg.isAffiliate.isRealeflow)
                        ? 6
                        : 12,
                  }}

                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <div data-tour="financing-step-1">
                    <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                      Loan Amount
                    </Box>
                    <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                      <Box
                        sx={{
                          display: 'flex',
                          p: '0.25rem',
                          alignItems: 'center',
                        }}
                      >
                        {/* <div>
                        fast
                      </div> */}
                        <Box
                          component="span"
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            whiteSpace: 'nowrap',
                            lineHeight: 1.3,
                          }}
                        >
                          <CountUp
                            start={0}
                            end={analytics.fixFlip.loanAmountFixFlip}
                            duration={1}
                            separator=","
                            decimals={0}
                            prefix="$"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </div>
                </Grid>
                {!activeOrg.isRealeflow &&
                  (!activeOrg.isAffiliate ||
                    !activeOrg.isAffiliate.isRealeflow) && (
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div data-tour="financing-step-2">
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Mortgage/mo
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            {/* <div>
                          normal
                        </div> */}
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={
                                  analytics.fixFlip.mortgageFixFlip
                                }
                                duration={1}
                                delay={2}
                                separator=","
                                decimals={0}
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                  )}
                {/* <Grid size={{md: 4}}>
                  <div>
                    <div>DSCR</div>
                    <div>
                      <div>
                      <div>
                        slow
                      </div>
                        <span>
                          <CountUp
                            start={0}
                            end={analytics.fixFlip.debtCoverageRatio}
                            duration={1}
                            delay={2}
                            separator=","
                            decimals={2}
                            suffix="x"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </Grid> */}
              </Grid>
            </Box>
            <Box
              component="p"
              
              data-tour="financing-step-3" sx={[strategyTextMuted802Sx, { mb: '1rem', textAlign: 'center' }]}>
              Based on your{' '}
              <b>
                {currencyFormat.format(
                  analytics.fixFlip.allInCostFixFlip,
                )}
              </b>{' '}
              <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
                <Box component="span"
                  
                  onClick={() => toggle1('All-in Cost')} sx={strategyLinkUnderlineBlueSx}>
                  all-in cost
                </Box>
              </Tooltip>
              , you'll need to pay{' '}
              <b>
                {currencyFormat.format(
                  analytics.fixFlip.totalOutOfPocketFixFlip,
                )}
              </b>{' '}
              <Tooltip title="Total amount that the buyer has to cover with their own money.">
                <Box component="span"
                  
                  onClick={() => toggle1('Total Out-of-Pocket')} sx={strategyLinkUnderlineBlueSx}>
                  out-of-pocket
                </Box>
              </Tooltip>{' '}
              to cover the downpayment, closing costs, and rehab for
              this property.
            </Box>
            <Divider sx={strategyBlockSpacerSx} />
            <Grid container>
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  {map(financingFields, (section) =>
                    renderInputFields(section),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'disposition',
      card: (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Disposition Expenses</b>
            </Box>
            <div>
              <Tooltip title="All costs and expenses associated with sale of this property">
                <Button
                  onClick={() =>
                    setOpenFixFlipDispositionExpensesTour(true)
                  }
                 
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      data-tour="dispositionExpenses-step-1"
                      options={dispositionChartOptions}
                      series={dispositionChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  {map(dispositionFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'comparableProperties',
      card: (
        <ComparablePropertiesCard
          basicView={props.basicView}
          compData={compData}
          onComparablePropertiesTourClick={
            toggleComparablePropertiesTour
          }
          onToggleCenter={props.toggleCenter}
          determinedComps={props.determinedComps}
          compProperties={props.compProperties}
        />
      ),
    },
    {
      name: 'piti',
      hide:
        activeOrg?.member !== 'pacemorby' &&
        activeOrg?.member !== 'astroflip',
      card: props.basicView ? null : (
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Deal Sauce Summary</b>
            </Box>
            <Select
              value={dealSauceView}
              name="dealSauceView"
              onChange={(event) =>
                setDealSauceView(event.target.value)
              }
              sx={strategyFullWidthSx}
            >
              <MenuItem value="cash" key="cash">
                Cash
              </MenuItem>
              <MenuItem value="creative" key="creative">
                Creative
              </MenuItem>
            </Select>
          </Box>
          <Divider />
          <CardContent>
            {dealSauceView === 'cash' && (
              <>
                <Box sx={[{ borderRadius: '0.65rem', p: '0.5rem', mb: '0.5rem', backgroundColor: '#f8f9ff', textAlign: 'center', }, { borderWidth: "1px !important", borderStyle: "solid !important" }]} sx={strategyBorderMutedSx}>
                  <Grid container sx={[strategyTextMuted802Sx, { fontSize: "0.875rem !important" }]}>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div>
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Entry Fee
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={strategyMinHeight50Sx}
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={cashEntryFee}
                                duration={0}
                                separator=","
                                delay={1}
                                decimals={0}
                                decimal="."
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div>
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Max Allowable Offer
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={strategyMinHeight50Sx}
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={
                                  analysis.afterRepairValue -
                                  cashEntryFee
                                }
                                duration={0}
                                separator=","
                                delay={1}
                                decimals={0}
                                decimal="."
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Grid size={12} sx={strategyMarginTop35Sx}>
                  <Grid container direction="column" spacing={4}>
                    <ContactInformation property={property} />
                  </Grid>
                </Grid>
                <CommentsDialog
                  property={property}
                  userId={props?.session?.me?._id}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                 
                  onClick={(e) => setOpenPITICashData(true)} sx={strategyMarginTop25Sx}>
                  <Typography>View Cash Underwriting</Typography>
                </Button>
              </>
            )}
            {dealSauceView === 'creative' && (
              <>
                <Box sx={[{ borderRadius: '0.65rem', p: '0.5rem', mb: '0.5rem', backgroundColor: '#f8f9ff', textAlign: 'center', }, { borderWidth: "1px !important", borderStyle: "solid !important" }]} sx={strategyBorderMutedSx}>
                  <Grid container sx={[strategyTextMuted802Sx, { fontSize: "0.875rem !important" }]}>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div>
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          Entry Fee
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={creativeEntryFee}
                                duration={1}
                                separator=","
                                delay={1}
                                decimals={0}
                                decimal="."
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                    <Grid
                      size={{ md: 6 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div>
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          PITI
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={pitiTotal}
                                duration={1}
                                separator=","
                                delay={1}
                                decimals={0}
                                decimal="."
                                prefix="$"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                    <Grid
                      size={{ md: 12 }}

                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div>
                        <Box sx={{ color: '#4f5062', pb: '0.25rem' }}>
                          % of Purchase Price
                        </Box>
                        <Box sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center', }, { fontSize: "1.15rem !important" }, strategyDarkTextSx]}>
                          <Box
                            sx={{
                              display: 'flex',
                              p: '0.25rem',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                lineHeight: 1.3,
                              }}
                            >
                              <CountUp
                                start={0}
                                end={
                                  analysis?.offerPrice &&
                                  analysis.offerPrice !== 0
                                    ? (creativeEntryFee /
                                        analysis.offerPrice) *
                                      100
                                    : 0
                                }
                                duration={1}
                                delay={1}
                                decimals={2}
                                decimal="."
                                suffix="%"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Grid container>
                  <Grid size={12}>
                    <Grid container direction="column" spacing={4}>
                      <ContactInformation property={property} />
                    </Grid>
                  </Grid>
                  <CommentsDialog
                    property={property}
                    userId={props?.session?.me?._id}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                   
                    onClick={(e) => setOpenPITICreativeData(true)} sx={strategyMarginTop25Sx}>
                    <Typography>
                      View Creative Underwriting
                    </Typography>
                  </Button>
                </Grid>
              </>
            )}
          </CardContent>
        </Card>
      ),
    },
    {
      name: 'deactive',
      card: <DeactiveCard />,
    },
  ]

  return (
    <>
      <StrategyPageBase
        cards={fixAndFlipCards}
        strategyName="Fix & Flip"
        strategyKey="fixAndFlip"
        property={property}
        activeOrg={activeOrg}
        canDrag={props.canDrag}
        publicDashboard={props.publicDashboard}
        publicImageCard={props.publicImageCard}
        session={props.session}
        renderInputFields={renderInputFields}
      />
      {map(financials, (section) => (
        <Dialog
          key={section.label}
          open={modal1 === section.label}
          onClose={toggle1Close}
          maxWidth="lg"
          scroll="body"
          slotProps={{ paper: { sx: calcDialogPaperSx } }}
        >
          {/* <BlockUi blocking={loader} loader={<PacmanLoader color={'var(--primary)'} loading={true} />}> */}
          <Grid container spacing={0}>
            <Grid size={5}>
              <Box sx={[{ height: '100%', borderRadius: '0.65rem' }, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                "& > .divider": { zIndex: 7, width: "100%" },
                "& .hero-footer": { zIndex: 7 },
                "& .header-nav-wrapper": { zIndex: 27 },
                "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                alignItems: "center",
                ".MuiCard-root > &": {
                  top: -1,
                  marginLeft: -1,
                  marginRight: -1,
                  marginBottom: -2,
                  zIndex: 6,
                },
                backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
              }, {
                "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
              }]}>
                <Box
                  sx={{
                    flexGrow: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={[strategyNavyBgSx, { borderRadius: '0.65rem' }, {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "100%",
                    zIndex: 5,
                    opacity: "0.7 !important",
                  }, {
                    "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                  }]}/>
                  <Box sx={[{ justifyContent: 'center', textAlign: 'center', p: '3rem', '@media (min-width: 1440px)': { justifyContent: 'flex-start', textAlign: 'left' }, }, { position: "relative", zIndex: "7", width: "100%" }]}>
                    <Box sx={{ color: '#fff', mt: '1rem' }}>
                      <Typography sx={strategyCardTitleSx}>
                        Calculation
                      </Typography>
                    </Box>
                    {section.calculation}
                    <Box sx={{ color: '#fff', mt: '1rem' }}>
                      <Typography>
                        * Calculation may be a few dollars off due to
                        rounding
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid size={7}>
              <div>
                <Card>
                  <CardHeader title={section.label} />
                  <Divider />
                  <CardContent sx={strategyFullHeight100Sx}>
                    <Grid
                      container
                      direction="row"
                      sx={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Grid size={12} sx={strategyMarginBottom10Sx}>
                        <Card sx={strategyMetricGrayBgSx}>
                          <CardContent>
                            <Typography>
                              {section.description}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid
                      container
                      sx={{
                        justifyContent: 'center',
                      }}
                    >
                      <Grid>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggle1Close}
                        >
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </div>
            </Grid>
          </Grid>
          {/* </BlockUi> */}
        </Dialog>
      ))}
      <SubtoPITICash
        open={openPITICashData}
        onClose={() => setOpenPITICashData(false)}
        propertyId={property?._id}
        address={property?.address}
        city={property.city}
        state={property.state}
        zipcode={property?.zip}
      />
      <SubtoPITICreative
        open={openPITICreativeData}
        onClose={() => setOpenPITICreativeData(false)}
        propertyId={property?._id}
        address={property?.address}
        city={property.city}
        state={property.state}
        zipcode={property?.zip}
      />

      <Dialog
        open={openConfirmLender}
        onClose={toggleOpenConfirmLender}
      >
        <DialogTitle>Disclaimer</DialogTitle>
        <DialogContent>
          Would you like to overwrite the % of Purchase Price, % of
          Rehab, Points, Interest Only, and Financing Fee values with
          the values from the selected lender?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              toggleOpenConfirmLender()
            }}
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={(event) => {
              toggleOpenConfirmLender()
              props.lenderOverride('FixFlip')
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <FixFlipStrategyTour
        isOpenFixFlipStrategyTour={openStrategyTour}
        closeFixFlipStrategyTour={closeStrategyTour}
      />
      <FixFlipTargetsTour
        isOpenFixFlipTargetsTour={openTargetsTour}
        closeFixFlipTargetsTour={closeTargetsTour}
      />
      <FixFlipNetProfitFromSaleTour
        isOpenFixFlipNetProfitFromSaleTour={openNetProfitTour}
        closeFixFlipNetProfitFromSaleTour={closeNetProfitTour}
      />
      <FixFlipAcquisitionExpensesTour
        isOpenFixFlipAcquisitionExpensesTour={
          openFixFlipAcquisitionExpensesTour
        }
        closeFixFlipAcquisitionExpensesTour={() =>
          setOpenFixFlipAcquisitionExpensesTour(false)
        }
      />
      {/* <FixFlipGrossMonthlyIncomeTour
      isOpenFixFlipGrossMonthlyIncomeTour={openFixFlipMonthlyIncomeTour} closeFixFlipGrossMonthlyIncomeTour={() => setOpenFixFlipMonthlyIncomeTour(false)}
    /> */}
      <FixFlipGrossMonthlyIncomeSingleRentTour
        isOpenFixFlipGrossMonthlyIncomeSingleRentTour={
          openFixFlipGrossMonthlyIncomeSingleRentTour
        }
        closeFixFlipGrossMonthlyIncomeSingleRentTour={() =>
          setOpenFixFlipGrossMonthlyIncomeSingleRentTour(false)
        }
      />
      <FixFlipGrossMonthlyIncomeRentRangeTour
        isOpenFixFlipGrossMonthlyIncomeRentRangeTour={
          openFixFlipGrossMonthlyIncomeRentRangeTour
        }
        closeFixFlipGrossMonthlyIncomeRentRangeTour={() =>
          setOpenFixFlipGrossMonthlyIncomeRentRangeTour(false)
        }
      />
      <FixFlipRehabExpensesSingleRehabValueTour
        isOpenFixFlipRehabExpensesSingleRehabValueTour={
          openFixFlipRehabExpensesSingleRehabValueTour
        }
        closeFixFlipRehabExpensesSingleRehabValueTour={() =>
          setOpenFixFlipRehabExpensesSingleRehabValueTour(false)
        }
      />
      <FixFlipRehabExpensesDetailedRehabTour
        isOpenFixFlipRehabExpensesDetailedRehabTour={
          openFixFlipRehabExpensesDetailedRehabTour
        }
        closeFixFlipRehabExpensesDetailedRehabTour={() =>
          setOpenFixFlipRehabExpensesDetailedRehabTour(false)
        }
      />
      <FixFlipRehabExpensesRehabTierTour
        isOpenFixFlipRehabExpensesRehabTierTour={
          openFixFlipRehabExpensesRehabTierTour
        }
        closeFixFlipRehabExpensesRehabTierTour={() =>
          setOpenFixFlipRehabExpensesRehabTierTour(false)
        }
      />
      <FixFlipRehabExpensesFlippingAmericaRehabTour
        isOpenFixFlipRehabExpensesFlippingAmericaRehabTour={
          openFixFlipRehabExpensesFlippingAmericaRehabTour
        }
        closeFixFlipRehabExpensesFlippingAmericaRehabTour={() =>
          setOpenFixFlipRehabExpensesFlippingAmericaRehabTour(false)
        }
      />
      <FixFlipHoldingExpensesTour
        isOpenFixFlipHoldingExpensesTour={
          openFixFlipHoldingExpensesTour
        }
        closeFixFlipHoldingExpensesTour={() =>
          setOpenFixFlipHoldingExpensesTour(false)
        }
      />
      <FixFlipFinancingTour
        isOpenFixFlipFinancingTour={openFixFlipFinancingTour}
        closeFixFlipFinancingTour={() =>
          setOpenFixFlipFinancingTour(false)
        }
      />
      <FixFlipDispositionExpensesTour
        isOpenFixFlipDispositionExpensesTour={
          openFixFlipDispositionExpensesTour
        }
        closeFixFlipDispositionExpensesTour={() =>
          setOpenFixFlipDispositionExpensesTour(false)
        }
      />
      <FixFlipComparablePropertiesTour
        isOpenFixFlipComparablePropertiesTour={
          openComparablePropertiesTour
        }
        closeFixFlipComparablePropertiesTour={
          closeComparablePropertiesTour
        }
      />
    </>
  )
}

export default withSession(CenterPageFixFlip)
